(function () {
  'use strict';

  const SAVED_WATCH_KEY = 'daluca_selected_watch_v1';
  const CUSTOM_URL = '/collections/custom-watch-straps';
  const MAX_BROAD_RESULTS = 40;
  const DESCRIPTION_IMAGE_ALTS = {
    'daluca-ooak-heavy-duty-1200.png': 'Heavy-duty DaLuca leather watch strap construction',
    'daluca-ooak-design-1200.png': 'DaLuca two-piece watch strap design and traditional fit',
    'daluca-ooak-comfort-1200.png': 'Supple and flexible DaLuca watch strap for all-day wear',
    'daluca-ooak-buckle-1200.png': 'DaLuca stainless steel watch strap buckle options',
    'daluca-ooak-thread-1200.png': 'DaLuca four-ply waxed linen watch strap thread',
    'daluca-ooak-fit-1200.png': 'DaLuca watch strap widths and wrist fit range',
    '1oak-step3b.jpg': 'How to choose the correct custom watch strap width',
    '1oak-step4.jpg': 'How to choose a custom watch strap length',
    '1oak-step5.jpg': 'DaLuca custom watch strap buckle types',
    '1oak-step6.jpg': 'DaLuca custom watch strap stitching types',
    '1oak-step7.jpg': 'DaLuca custom watch strap stitching colors',
    '1oak-step8.jpg': 'DaLuca custom watch strap keeper options',
    '1oak-step9.jpg': 'Venetian Cream leather conditioner for custom watch straps'
  };

  function trackEvent(name, details) {
    const payload = Object.assign({ event: name }, details || {});
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
    document.dispatchEvent(new CustomEvent(name, { bubbles: true, detail: payload }));
  }

  function compact(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/&/g, ' and ')
      .replace(/[^a-z0-9]+/g, '');
  }

  function words(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, ' ')
      .trim()
      .split(/\s+/)
      .filter(Boolean);
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function displayModel(record) {
    return String(record.display_model || record.model || '').trim();
  }

  function displayReference(record) {
    return String(
      record._display_reference ||
      record.display_reference ||
      record.canonical_reference ||
      record.reference ||
      ''
    ).trim();
  }

  function recordSearchText(record) {
    if (record._dalucaPdpSearch) return record._dalucaPdpSearch;
    const values = [
      record.brand,
      record.model,
      record.display_model,
      record.reference,
      record.display_reference,
      record.canonical_reference,
      record.family,
      record.series,
      Array.isArray(record.aliases) ? record.aliases.join(' ') : record.aliases,
      Array.isArray(record.search_terms) ? record.search_terms.join(' ') : record.search_terms
    ];
    record._dalucaPdpSearch = values.filter(Boolean).join(' ').toLowerCase();
    record._dalucaPdpCompact = compact(record._dalucaPdpSearch);
    return record._dalucaPdpSearch;
  }

  function scoreRecord(record, query) {
    const queryWords = words(query);
    const queryCompact = compact(query);
    const searchText = recordSearchText(record);
    const searchCompact = record._dalucaPdpCompact;
    const ref = compact(displayReference(record));
    const model = compact(displayModel(record));
    const brand = compact(record.brand);

    if (!queryCompact || queryWords.length === 0) return -1;
    if (!queryWords.every((word) => searchText.includes(word) || searchCompact.includes(compact(word)))) return -1;

    let score = 0;
    if (ref && queryCompact === ref) score += 1000;
    else if (ref && ref.startsWith(queryCompact)) score += 700;
    else if (ref && queryCompact.includes(ref)) score += 520;
    if (model && queryCompact === model) score += 650;
    else if (model && model.startsWith(queryCompact)) score += 430;
    else if (model && model.includes(queryCompact)) score += 300;
    if (brand && queryCompact.startsWith(brand)) score += 90;
    if (searchCompact.startsWith(queryCompact)) score += 130;
    score += Math.max(0, 80 - Math.abs(searchCompact.length - queryCompact.length));
    return score;
  }

  function uniqueResults(records, query) {
    const seen = new Set();
    const matches = records
      .map((record) => ({ record: record, score: scoreRecord(record, query) }))
      .filter((entry) => entry.score >= 0)
      .sort((a, b) => b.score - a.score)
      .filter((entry) => {
        const record = entry.record;
        const key = [record.brand, displayModel(record), displayReference(record), record.lug_width_mm]
          .map(compact)
          .join('|');
        if (seen.has(key)) return false;
        seen.add(key);
        return true;
      })
      .map((entry) => entry.record);

    return compact(query).length < 3 ? matches.slice(0, MAX_BROAD_RESULTS) : matches;
  }

  function loadDatabase(url) {
    if (window.DaLucaPdpWatchDatabase) {
      return Promise.resolve(window.DaLucaPdpWatchDatabase);
    }
    if (window.DaLucaPdpWatchDatabasePromise) {
      return window.DaLucaPdpWatchDatabasePromise;
    }

    window.DaLucaPdpWatchDatabasePromise = window.DaLucaWatchData.load()
      .then((json) => {
        const source = Array.isArray(json.records) ? json.records : [];
        window.DaLucaPdpWatchDatabase = source.filter((record) => {
          const status = String(record.verification_status || '').toUpperCase();
          return record.brand && record.model && Number(record.lug_width_mm) && status.startsWith('VERIFIED');
        });
        return window.DaLucaPdpWatchDatabase;
      })
      .catch((error) => {
        window.DaLucaPdpWatchDatabasePromise = null;
        throw error;
      });

    return window.DaLucaPdpWatchDatabasePromise;
  }

  function readSavedWatch() {
    try {
      const saved = JSON.parse(localStorage.getItem(SAVED_WATCH_KEY) || 'null');
      return saved && Number(saved.lug_width_mm) ? window.DaLucaWatchData.safeSaved(saved) : null;
    } catch (error) {
      return null;
    }
  }

  function saveWatch(record) {
    try {
      localStorage.setItem(SAVED_WATCH_KEY, JSON.stringify(record));
    } catch (error) {
      // Storage can be unavailable in strict privacy modes; fit checking still works.
    }
  }

  function selectMatchingWidth(width) {
    const target = String(width).replace(/\s*mm$/i, '');
    const selectors = Array.from(document.querySelectorAll('variant-selects'));

    selectors.forEach((selector) => {
      const fields = Array.from(selector.querySelectorAll('input[type="radio"], select'));
      fields.forEach((field) => {
        if (field.tagName === 'SELECT') {
          const option = Array.from(field.options).find((item) => {
            return String(item.value).replace(/\s*mm$/i, '') === target;
          });
          if (option && !option.disabled) {
            field.value = option.value;
            field.dispatchEvent(new Event('change', { bubbles: true }));
          }
          return;
        }

        const value = String(field.value || field.dataset.value || '').replace(/\s*mm$/i, '');
        if (value === target && !field.disabled && !field.classList.contains('is-disabled')) {
          field.click();
        }
      });
    });
  }

  function initFitChecker(root) {
    if (root.dataset.dalucaReady === 'true') return;
    root.dataset.dalucaReady = 'true';

    const databaseUrl = root.dataset.databaseUrl;
    const productWidths = new Set(
      String(root.dataset.productWidths || '')
        .split(',')
        .map((value) => String(value).trim())
        .filter(Boolean)
    );
    const customAnyWidth = root.dataset.customAnyWidth === 'true';
    const input = root.querySelector('[data-daluca-pdp-fit-input]');
    const clear = root.querySelector('[data-daluca-pdp-fit-clear]');
    const results = root.querySelector('[data-daluca-pdp-fit-results]');
    const answer = root.querySelector('[data-daluca-pdp-fit-answer]');
    const saved = root.querySelector('[data-daluca-pdp-fit-saved]');
    let database = [];
    let databaseLoading = false;
    let activeIndex = -1;
    let latestResults = [];

    function closeResults() {
      results.hidden = true;
      window.DaLucaI18n.setHtml(results, '');
      input.setAttribute('aria-expanded', 'false');
      activeIndex = -1;
    }

    function ensureLocalDatabase() {
      if (database.length) return Promise.resolve(database);
      if (databaseLoading) return window.DaLucaPdpWatchDatabasePromise;
      databaseLoading = true;
      if (input.value.trim().length >= 2) {
        results.hidden = false;
        window.DaLucaI18n.setHtml(results, '<div class="daluca-pdp-fit__loading">Loading watch reference data…</div>');
        input.setAttribute('aria-expanded', 'true');
      }
      return loadDatabase(databaseUrl)
        .then((records) => {
          database = records;
          databaseLoading = false;
          closeResults();
          if (input.value.trim().length >= 2) renderResults(input.value);
          return records;
        })
        .catch((error) => {
          databaseLoading = false;
          closeResults();
          input.placeholder = 'Fit search unavailable — open the full Strap Finder';
          throw error;
        });
    }

    function showSavedWatch() {
      const watch = readSavedWatch();
      if (!watch) {
        saved.hidden = true;
        return;
      }
      const label = [watch.brand, displayModel(watch), displayReference(watch)]
        .filter(Boolean)
        .join(' ');
      window.DaLucaI18n.setHtml(saved, '<button type="button">Use saved watch: ' + escapeHtml(label) + ' · ' + escapeHtml(watch.lug_width_mm) + 'mm</button>');
      saved.hidden = false;
      saved.querySelector('button').addEventListener('click', () => chooseWatch(watch));
    }

    function renderAnswer(record) {
      const width = String(Number(record.lug_width_mm));
      const watchName = [record.brand, displayModel(record), displayReference(record)]
        .filter(Boolean)
        .join(' ');
      const data=window.DaLucaWatchData;
      if(data.requiresReview(record)||!data.canOrderWidth(width)){
        answer.className='daluca-pdp-fit__answer is-mismatch';answer.hidden=false;
        const strong=document.createElement('strong');window.DaLucaI18n.setText(strong, data.text.title);
        const detail=document.createElement('p');window.DaLucaI18n.setText(detail, watchName+' · '+data.text.width_label+': '+width+'mm. '+(data.requiresReview(record)?data.reviewMessage(record):data.text.range));
        const contact=document.createElement('a');contact.href='mailto:info@dalucastraps.com';window.DaLucaI18n.setText(contact, data.text.action);
        answer.replaceChildren(strong,detail,contact);
        const source=data.sourceUrl(record);if(source){const link=document.createElement('a');link.href=source;link.target='_blank';link.rel='noopener';window.DaLucaI18n.setText(link, data.text.source);link.style.marginInlineStart='12px';answer.append(link);}
        return;
      }
      const fits = customAnyWidth || productWidths.has(width);

      answer.className = 'daluca-pdp-fit__answer';
      answer.hidden = false;

      if (fits) {
        answer.classList.add(customAnyWidth ? 'is-custom' : 'is-fit');
        const heading=(customAnyWidth?data.text.pdp_custom:data.text.pdp_match).replace('__width__',width);
        const detail=data.text.pdp_detail.replace('__watch__',watchName).replace('__width__',width);
        window.DaLucaI18n.setHtml(answer, '<strong>'+escapeHtml(heading)+'</strong>'+escapeHtml(detail)+' '+escapeHtml(data.text.width_note));
        if (!customAnyWidth) selectMatchingWidth(width);
      } else {
        answer.classList.add('is-mismatch');
        const heading=data.text.pdp_mismatch.replace('__width__',width);
        const linkText=data.text.pdp_custom_link.replace('__width__',width);
        window.DaLucaI18n.setHtml(answer, '<strong>'+escapeHtml(heading)+'</strong>'+escapeHtml(data.text.width_note)+' <a href="'+CUSTOM_URL+'?daluca_custom_width='+encodeURIComponent(width)+'">'+escapeHtml(linkText)+'</a>');
      }

      trackEvent('daluca_pdp_fit_checked', {
        watch_brand: String(record.brand || ''),
        watch_model: displayModel(record),
        required_width_mm: Number(record.lug_width_mm),
        result: fits ? (customAnyWidth ? 'custom_available' : 'ready_made_width_match') : 'custom_required'
      });
    }

    function chooseWatch(record) {
      saveWatch(record);
      const label = [record.brand, displayModel(record), displayReference(record)]
        .filter(Boolean)
        .join(' ');
      input.value = label;
      clear.hidden = false;
      closeResults();
      renderAnswer(record);
      showSavedWatch();
    }

    function renderResults(query) {
      if (query.trim().length < 2) {
        closeResults();
        return;
      }

      latestResults = uniqueResults(database, query);
      results.hidden = false;
      input.setAttribute('aria-expanded', 'true');
      activeIndex = -1;

      if (latestResults.length === 0) {
        window.DaLucaI18n.setHtml(results, '<div class="daluca-pdp-fit__empty">No exact result yet. Try the brand, model family or reference number.</div>');
        return;
      }

      const resultSummary = '<div class="daluca-pdp-fit__result-summary">' +
        escapeHtml(latestResults.length) + ' reference ' + (latestResults.length === 1 ? 'match' : 'matches') +
        '<span>Type more of the reference to narrow the list.</span></div>';

      window.DaLucaI18n.setHtml(results, resultSummary + latestResults.map((record, index) => {
        const reference = displayReference(record);
        const meta = [record.brand, reference ? 'Ref. ' + reference : ''].filter(Boolean).join(' · ');
        return '<button type="button" class="daluca-pdp-fit__result" role="option" data-index="' + index + '">' +
          '<span><strong>' + escapeHtml(displayModel(record)) + '</strong><small>' + escapeHtml(meta) + '</small></span>' +
          '<em>' + escapeHtml(record.lug_width_mm) + 'mm</em></button>';
      }).join(''));

      results.querySelectorAll('[data-index]').forEach((button) => {
        button.addEventListener('click', () => chooseWatch(latestResults[Number(button.dataset.index)]));
      });
    }

    function setActiveResult(nextIndex) {
      const buttons = Array.from(results.querySelectorAll('[data-index]'));
      if (!buttons.length) return;
      activeIndex = (nextIndex + buttons.length) % buttons.length;
      buttons.forEach((button, index) => {
        button.classList.toggle('is-active', index === activeIndex);
        button.setAttribute('aria-selected', index === activeIndex ? 'true' : 'false');
      });
      buttons[activeIndex].scrollIntoView({ block: 'nearest' });
    }

    input.addEventListener('focus', () => {
      if (input.value.trim().length >= 2) {
        if (database.length) renderResults(input.value);
        else ensureLocalDatabase().catch(() => {});
      }
    });

    input.addEventListener('input', () => {
      clear.hidden = input.value.length === 0;
      answer.hidden = true;
      if (input.value.trim().length < 2) {
        closeResults();
      } else if (database.length) {
        renderResults(input.value);
      } else {
        ensureLocalDatabase().catch(() => {});
      }
    });

    input.addEventListener('keydown', (event) => {
      if (results.hidden) return;
      if (event.key === 'ArrowDown') {
        event.preventDefault();
        setActiveResult(activeIndex + 1);
      } else if (event.key === 'ArrowUp') {
        event.preventDefault();
        setActiveResult(activeIndex - 1);
      } else if (event.key === 'Enter' && activeIndex >= 0) {
        event.preventDefault();
        chooseWatch(latestResults[activeIndex]);
      } else if (event.key === 'Escape') {
        closeResults();
      }
    });

    clear.addEventListener('click', () => {
      input.value = '';
      answer.hidden = true;
      clear.hidden = true;
      closeResults();
      input.focus();
    });

    document.addEventListener('click', (event) => {
      if (!root.contains(event.target)) closeResults();
    });

    showSavedWatch();

    if (!databaseUrl) {
      input.disabled = true;
      input.placeholder = 'Watch database URL needs to be added in theme settings';
      return;
    }

    // The database loads only when the customer uses search, keeping initial PDP load light.
  }

  function initSecondColorLinks() {
    document.querySelectorAll('[data-daluca-choose-second-color]').forEach((button) => {
      if (button.dataset.dalucaReady === 'true') return;
      button.dataset.dalucaReady = 'true';
      button.addEventListener('click', () => {
        const colorField = Array.from(document.querySelectorAll('.product-form__input')).find((field) => {
          const label = field.querySelector('.form__label');
          return label && /color/i.test(window.DaLucaI18n.sourceText(label));
        });
        if (colorField) {
          colorField.scrollIntoView({ behavior: 'smooth', block: 'center' });
          colorField.setAttribute('tabindex', '-1');
          colorField.focus({ preventScroll: true });
        }
      });
    });
  }

  function initGalleryCounters() {
    document.querySelectorAll('[data-daluca-gallery-counter]').forEach((counter) => {
      if (counter.dataset.dalucaReady === 'true') return;
      const gallery = counter.closest('.product-image-container');
      const slider = gallery ? gallery.querySelector('product-slider') : null;
      const current = counter.querySelector('[data-daluca-gallery-current]');
      const total = counter.querySelector('[data-daluca-gallery-total]');
      if (!slider || !current || !total) return;

      const update = () => {
        const slides = Array.from(slider.querySelectorAll('.product-images__slide.is-active'));
        const selected = slides.findIndex((slide) => slide.classList.contains('is-selected'));
        window.DaLucaI18n.setText(total, String(slides.length || 1));
        window.DaLucaI18n.setText(current, String(selected >= 0 ? selected + 1 : 1));
      };

      counter.dataset.dalucaReady = 'true';
      update();
      const observer = new MutationObserver(update);
      observer.observe(slider, { attributes: true, subtree: true, attributeFilter: ['class'] });
    });
  }

  function initGalleryNavigation() {
    document.querySelectorAll('.daluca-pdp product-slider.product-images').forEach((slider) => {
      if (slider.dataset.dalucaNavigationReady === 'true') return;

      const previousButton = slider.querySelector('.flickity-prev');
      const nextButton = slider.querySelector('.flickity-next');

      const update = () => {
        const activeSlides = slider.querySelectorAll('.product-images__slide.is-active');
        slider.classList.toggle('daluca-gallery--multiple', activeSlides.length > 1);
        slider.classList.toggle('daluca-gallery--single', activeSlides.length <= 1);
        const gallery = slider.closest('.product-gallery-container');
        if (gallery) gallery.dataset.dalucaMediaCount = String(activeSlides.length);
      };

      slider.dataset.dalucaNavigationReady = 'true';
      if (previousButton) {
        previousButton.setAttribute('role', 'button');
        previousButton.setAttribute('aria-label', 'Previous product image');
      }
      if (nextButton) {
        nextButton.setAttribute('role', 'button');
        nextButton.setAttribute('aria-label', 'Next product image');
      }
      update();

      new MutationObserver(update).observe(slider, {
        attributes: true,
        subtree: true,
        attributeFilter: ['class']
      });
    });
  }

  function initGalleryHoverZoom() {
    const canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    document.querySelectorAll('.daluca-pdp .product-single__media-image').forEach((frame) => {
      if (frame.dataset.dalucaZoomReady === 'true') return;
      const image = frame.querySelector('img');
      const zoomLink = frame.querySelector('.product-single__media-zoom');
      if (!image || !zoomLink) return;

      let pointerStart = null;
      frame.dataset.dalucaZoomReady = 'true';
      frame.classList.add('daluca-gallery__zoom-frame');
      image.draggable = false;

      frame.addEventListener('pointerdown', (event) => {
        pointerStart = { x: event.clientX, y: event.clientY };
      });

      if (canHover) {
        frame.addEventListener('pointerenter', () => {
          image.classList.add('is-daluca-hover-zoomed');
        });
        frame.addEventListener('pointermove', (event) => {
          const bounds = frame.getBoundingClientRect();
          const x = Math.max(0, Math.min(100, ((event.clientX - bounds.left) / bounds.width) * 100));
          const y = Math.max(0, Math.min(100, ((event.clientY - bounds.top) / bounds.height) * 100));
          image.style.transformOrigin = x + '% ' + y + '%';
        });
        frame.addEventListener('pointerleave', () => {
          image.classList.remove('is-daluca-hover-zoomed');
          image.style.transformOrigin = '50% 50%';
          pointerStart = null;
        });
      }

      image.addEventListener('click', (event) => {
        if (pointerStart) {
          const moved = Math.hypot(event.clientX - pointerStart.x, event.clientY - pointerStart.y);
          if (moved > 8) return;
        }
        trackEvent('daluca_pdp_gallery_opened');
        zoomLink.click();
      });
    });
  }

  function initPriceInAddButton() {
    document.querySelectorAll('.daluca-pdp').forEach((root) => {
      if (root.dataset.dalucaPriceButtonReady === 'true') return;
      const priceRoot = root.querySelector('.product-price-container');
      const button = root.querySelector('.product-form .single-add-to-cart-button[name="add"]');
      const label = button ? button.querySelector(':scope > span:first-child') : null;
      if (!priceRoot || !button || !label) return;

      const baseLabel = button.dataset.dalucaBaseLabel || window.DaLucaI18n.sourceText(label).trim() || 'Add to cart';
      button.dataset.dalucaBaseLabel = baseLabel;
      const update = () => {
        if (button.disabled || button.classList.contains('sold-out')) return;
        const amount = priceRoot.querySelector('ins .amount');
        if (!amount) return;
        const upgradeToggle = root.querySelector('[data-daluca-quick-release-toggle]');
        const upgradedTotal = root.querySelector('[data-daluca-total-upgraded]');
        const displayAmount = upgradeToggle && upgradeToggle.checked && upgradedTotal
          ? window.DaLucaI18n.sourceText(upgradedTotal).trim()
          : window.DaLucaI18n.sourceText(amount).trim();
        window.DaLucaI18n.setText(label, baseLabel + ' — ' + displayAmount);
      };

      root.dataset.dalucaPriceButtonReady = 'true';
      update();
      new MutationObserver(update).observe(priceRoot, { childList: true, subtree: true, characterData: true });
      root.addEventListener('daluca:upgrade-change', update);
    });
  }

  function initProductStory() {
    document.querySelectorAll('[data-daluca-story-target]').forEach((target) => {
      if (target.dataset.dalucaReady === 'true') return;
      const source = document.querySelector('.daluca-product-details__description[data-daluca-description]');
      if (!source) return;

      const intro = source.querySelector('.product-features, .custom-features') || source;
      const copy = target.querySelector('[data-daluca-story-copy]');
      const specs = target.querySelector('[data-daluca-story-specs]');
      const primaryList = intro.querySelector(':scope > ul') || source.querySelector('.product-features ul, .custom-features ul');
      let contentMoved = false;

      const heading = intro.querySelector(':scope > h2');
      const subheading = intro.querySelector(':scope > h5');
      const paragraph = intro.querySelector(':scope > p') || source.querySelector('.prod-overview');

      [heading, subheading, paragraph].forEach((node) => {
        if (!node || !copy) return;
        copy.appendChild(node);
        contentMoved = true;
      });

      if (primaryList && specs) {
        const specNames = /^(length|width|widths|thickness|buckle|hardware|material|features)$/i;
        Array.from(primaryList.children).forEach((item) => {
          const normalizedText = String(window.DaLucaI18n.sourceText(item) || '').replace(/\s+/g, ' ').trim();
          const colonIndex = normalizedText.indexOf(':');
          if (colonIndex < 1) return;
          const name = normalizedText.slice(0, colonIndex).trim();
          const value = normalizedText.slice(colonIndex + 1).trim();

          if (/^description$/i.test(name) && value && !paragraph) {
            const storyParagraph = document.createElement('p');
            const htmlColonIndex = item.innerHTML.indexOf(':');
            window.DaLucaI18n.setHtml(storyParagraph, htmlColonIndex > -1 ? item.innerHTML.slice(htmlColonIndex + 1).trim() : escapeHtml(value));
            copy.appendChild(storyParagraph);
            item.remove();
            contentMoved = true;
            return;
          }

          if (!specNames.test(name) || !value) return;
          const term = document.createElement('dt');
          const detail = document.createElement('dd');
          window.DaLucaI18n.setText(term, name === 'Widths' ? 'Width' : name);
          const productRoot = target.closest('.daluca-pdp');
          const preciseMaterial = productRoot ? String(productRoot.dataset.dalucaProductMaterial || '').trim() : '';
          window.DaLucaI18n.setText(detail, /^material$/i.test(name) && preciseMaterial ? preciseMaterial : value);
          specs.appendChild(term);
          specs.appendChild(detail);
          item.remove();
          contentMoved = true;
        });

        if (!primaryList.children.length) primaryList.remove();
        specs.hidden = specs.children.length === 0;
      }

      if (contentMoved) target.hidden = false;
      target.dataset.dalucaReady = 'true';
    });
  }

  function collectLineItemProperties(form) {
    const properties = {};
    new FormData(form).forEach((value, key) => {
      const match = String(key).match(/^properties\[(.+)\]$/);
      if (match && String(value).trim()) properties[match[1]] = value;
    });
    return properties;
  }

  function initQuickReleaseUpgrade() {
    document.querySelectorAll('[data-daluca-quick-release]').forEach((upgrade) => {
      if (upgrade.dataset.dalucaReady === 'true') return;
      const root = upgrade.closest('.daluca-pdp');
      const toggle = upgrade.querySelector('[data-daluca-quick-release-toggle]');
      const productFormElement = root ? root.querySelector('product-form:not([data-sticky])') : null;
      const form = productFormElement ? productFormElement.querySelector('form[data-type="add-to-cart-form"]') : null;
      const baseTotal = root ? root.querySelector('[data-daluca-total-base]') : null;
      const upgradedTotal = root ? root.querySelector('[data-daluca-total-upgraded]') : null;
      if (!root || !toggle || !form || !productFormElement) return;

      upgrade.dataset.dalucaReady = 'true';

      const updateTotal = () => {
        if (baseTotal) baseTotal.hidden = toggle.checked;
        if (upgradedTotal) upgradedTotal.hidden = !toggle.checked;
        root.dispatchEvent(new CustomEvent('daluca:upgrade-change'));
        trackEvent('daluca_pdp_quick_release_toggled', { selected: toggle.checked });
      };

      toggle.addEventListener('change', updateTotal);

      form.addEventListener('submit', (event) => {
        if (!toggle.checked) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        if (!form.reportValidity()) return;

        const submitButtons = document.querySelectorAll('.single-add-to-cart-button');
        const errorWrapper = productFormElement.querySelector('.product-form__error-message-wrapper');
        const errorMessage = errorWrapper ? errorWrapper.querySelector('.product-form__error-message') : null;
        submitButtons.forEach((button) => {
          button.setAttribute('aria-disabled', 'true');
          button.classList.add('loading');
        });
        if (errorWrapper) errorWrapper.hidden = true;

        const formData = new FormData(form);
        const baseVariantId = Number(formData.get('id'));
        const upgradeVariantId = Number(upgrade.dataset.upgradeVariantId);
        const quantity = Math.max(1, Number(formData.get('quantity')) || 1);
        const items = [{ id: baseVariantId, quantity: quantity }];
        const properties = collectLineItemProperties(form);
        if (Object.keys(properties).length) items[0].properties = properties;
        if (formData.get('selling_plan')) items[0].selling_plan = Number(formData.get('selling_plan'));
        items.push({
          id: upgradeVariantId,
          quantity: 1,
          properties: { 'For strap': window.DaLucaI18n.chainText(() => (document), [{kind:"member", optional:false, computed:false, key: () => ("querySelector")}, {kind:"call", optional:false, args: () => ['.daluca-concierge-header h1']}, {kind:"text", optional:true}, {kind:"member", optional:false, computed:false, key: () => ("trim")}, {kind:"call", optional:false, args: () => []}]) || 'DaLuca strap' }
        });

        const sections = typeof productFormElement.getSectionsToRender === 'function'
          ? productFormElement.getSectionsToRender().map((section) => section.section)
          : ['cart-drawer', 'cart-bubble'];

        fetch((window.theme && theme.routes && theme.routes.cart_add_url) || '/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({ items: items, sections: sections, sections_url: window.location.pathname })
        })
          .then((response) => response.json().then((data) => {
            if (!response.ok || data.status) return Promise.reject(data);
            return data;
          }))
          .then((response) => {
            if (typeof productFormElement.renderContents === 'function' && response.sections) {
              productFormElement.renderContents(response);
            } else {
              document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            }
            document.dispatchEvent(new CustomEvent('cart:item-added', {
              bubbles: true,
              detail: { product: response.items && response.items[0] ? response.items[0] : response }
            }));
            trackEvent('daluca_pdp_quick_release_added', {
              base_variant_id: baseVariantId,
              upgrade_variant_id: upgradeVariantId
            });
          })
          .catch((error) => {
            if (errorWrapper) errorWrapper.hidden = false;
            if (errorMessage) window.DaLucaI18n.setText(errorMessage, (error && (error.description || error.message)) || 'The strap and quick-release upgrade could not be added. Please try again.');
          })
          .finally(() => {
            submitButtons.forEach((button) => {
              button.classList.remove('loading');
              button.removeAttribute('aria-disabled');
            });
          });
      }, true);
    });
  }

  function initMerchandisingTracking() {
    document.querySelectorAll('[data-daluca-upsell-name]').forEach((button) => {
      if (button.dataset.dalucaTrackingReady === 'true') return;
      button.dataset.dalucaTrackingReady = 'true';
      button.addEventListener('click', () => {
        trackEvent('daluca_pdp_addition_selected', {
          addition_name: String(button.dataset.dalucaUpsellName || '')
        });
      });
    });

    document.querySelectorAll('[data-daluca-rotation-link]').forEach((link) => {
      if (link.dataset.dalucaTrackingReady === 'true') return;
      link.dataset.dalucaTrackingReady = 'true';
      link.addEventListener('click', () => trackEvent('daluca_pdp_second_strap_clicked'));
    });

    if (document.documentElement.dataset.dalucaRecommendationTrackingReady !== 'true') {
      document.documentElement.dataset.dalucaRecommendationTrackingReady = 'true';
      document.addEventListener('click', (event) => {
        const link = event.target.closest('product-recommendations .products a');
        if (!link) return;
        trackEvent('daluca_pdp_recommendation_clicked', {
          recommendation_url: link.getAttribute('href') || ''
        });
      });
    }
  }

  function initProductDescriptions() {
    document.querySelectorAll('[data-daluca-description]').forEach((root) => {
      if (root.dataset.dalucaReady === 'true') return;
      root.dataset.dalucaReady = 'true';

      const callouts = Array.from(root.querySelectorAll('.product-callouts'));
      callouts.forEach((group, index) => {
        group.classList.add('daluca-description-callouts-group');
        group.classList.add(index === 0 ? 'daluca-description-callouts-group--top' : 'daluca-description-callouts-group--bottom');
        group.setAttribute('aria-label', index === 0 ? 'Product benefits' : 'Product construction details');
      });

      const detailsSection = root.closest('.daluca-product-details');
      const journeyProcess = detailsSection ? detailsSection.querySelector('[data-daluca-journey-process]') : null;
      if (journeyProcess && callouts.length) {
        callouts.forEach((group) => group.remove());
        detailsSection.classList.add('daluca-product-details--journey-ready');
      }

      root.querySelectorAll('a').forEach((link) => {
        const href = String(link.getAttribute('href') || '');
        if (/venetian-cream/i.test(href) || /venetian cream/i.test(window.DaLucaI18n.sourceText(link))) {
          link.setAttribute('href', '/collections/leather-care/products/venetian-cream-4oz');
        }
      });

      root.querySelectorAll('li, p').forEach((node) => {
        const text = String(window.DaLucaI18n.sourceText(node) || '').replace(/\s+/g, ' ').trim();
        if (/^we highly recommend adding a bottle of venetian cream\b/i.test(text)) {
          node.remove();
        }
      });

      root.querySelectorAll('ul').forEach((list) => {
        if (!list.children.length) list.remove();
      });

      root.querySelectorAll('img').forEach((image) => {
        const imageUrl = String(image.currentSrc || image.getAttribute('src') || image.dataset.src || '');
        const filename = imageUrl.split('?')[0].split('/').pop();
        if (filename === '1oak-step4.jpg') {
          const diagram = document.querySelector('[data-daluca-length-diagram]')?.dataset.dalucaLengthDiagram;
          if (diagram) {
            image.src = diagram;
            image.removeAttribute('srcset');
            image.removeAttribute('data-srcset');
            image.dataset.src = diagram;
            image.alt = 'Strap length: measure the short piece from the leather fold to the lug end, excluding the buckle; measure the long piece from end to tip.';
          }
        }
        if (!image.getAttribute('alt') && DESCRIPTION_IMAGE_ALTS[filename]) {
          image.setAttribute('alt', DESCRIPTION_IMAGE_ALTS[filename]);
        }
      });

      root.querySelectorAll('.detail-item').forEach((item) => {
        item.classList.toggle('daluca-detail-item--text-only', !item.querySelector('img'));
      });

      root.querySelectorAll('p').forEach((paragraph) => {
        if (paragraph.querySelector('img') && window.DaLucaI18n.sourceText(paragraph).trim() === '' && !paragraph.closest('.detail-item')) {
          paragraph.classList.add('daluca-description-legacy-image');
        }
      });

      root.querySelectorAll('ul').forEach((list) => {
        if (list.closest('.product-callouts') || list.closest('.details-list')) return;
        list.classList.add('daluca-description-list');
        list.querySelectorAll(':scope > li').forEach((item) => {
          const text = window.DaLucaI18n.sourceText(item).replace(/\s+/g, ' ').trim();
          const match = text.match(/^([^:]{2,32}):\s*(.+)/);
          const isLong = text.length > 145 || /^(description|recommended use|directions)/i.test(match ? match[1] : '');
          item.classList.add(isLong ? 'daluca-description-copy' : 'daluca-description-spec');

          if (match && !item.querySelector('.daluca-description-label')) {
            const html = item.innerHTML;
            const colonIndex = html.indexOf(':');
            if (colonIndex > -1 && colonIndex < 80) {
              window.DaLucaI18n.setHtml(item, '<strong class="daluca-description-label">' + html.slice(0, colonIndex) + '</strong>' +
                '<span class="daluca-description-value">' + html.slice(colonIndex + 1).trim() + '</span>');
            }
          }
        });
      });
    });
  }

  function readReviewState(widget) {
    const reviewCards = widget.querySelectorAll('.jdgm-rev');
    if (reviewCards.length > 0) return true;

    const reviewCountNodes = Array.from(widget.querySelectorAll('[data-number-of-reviews]'));
    if (widget.matches('[data-number-of-reviews]')) reviewCountNodes.unshift(widget);
    const reviewCounts = reviewCountNodes
      .map((node) => Number(node.getAttribute('data-number-of-reviews')))
      .filter((count) => Number.isFinite(count));
    if (reviewCounts.some((count) => count > 0)) return true;
    if (reviewCounts.some((count) => count === 0)) return false;

    const text = String(window.DaLucaI18n.sourceText(widget) || '').replace(/\s+/g, ' ').trim().toLowerCase();
    if (/\b[1-9][0-9,]*\s+(?:verified\s+)?reviews?\b/.test(text)) return true;
    if (/\b(?:0\s+reviews?|no\s+reviews?|be\s+the\s+first)\b/.test(text)) return false;

    return null;
  }

  function initReviewVisibility() {
    document.querySelectorAll('.daluca-review-intro').forEach((intro) => {
      if (intro.dataset.dalucaVisibilityReady === 'true') return;
      intro.dataset.dalucaVisibilityReady = 'true';

      const introSection = intro.closest('.shopify-section') || intro;
      let attempts = 0;
      let observedWidget = null;
      let widgetObserver = null;

      const applyState = (widget, state) => {
        const widgetSection = widget.closest('.shopify-section') || widget;
        introSection.hidden = !state;
        widgetSection.hidden = !state;
      };

      const check = () => {
        const widgets = Array.from(document.querySelectorAll('.jdgm-rev-widg'));
        const widget = widgets.find((candidate) => {
          return intro.compareDocumentPosition(candidate) & Node.DOCUMENT_POSITION_FOLLOWING;
        }) || widgets[0];

        if (widget) {
          if (widget !== observedWidget) {
            if (widgetObserver) widgetObserver.disconnect();
            observedWidget = widget;
            widgetObserver = new MutationObserver(() => {
              const updatedState = readReviewState(widget);
              if (updatedState !== null) applyState(widget, updatedState);
            });
            widgetObserver.observe(widget, {
              attributes: true,
              childList: true,
              subtree: true,
              characterData: true
            });
          }

          const state = readReviewState(widget);
          if (state !== null) {
            applyState(widget, state);
            return;
          }
        }

        attempts += 1;
        if (attempts < 40) {
          window.setTimeout(check, 250);
        } else {
          introSection.hidden = true;
        }
      };

      check();
    });
  }

  function initBundleButtons() {
    document.querySelectorAll('[data-daluca-bundle-add]').forEach((button) => {
      if (button.dataset.dalucaReady === 'true') return;
      button.dataset.dalucaReady = 'true';

      button.addEventListener('click', () => {
        const ids = String(button.dataset.dalucaBundleIds || '')
          .split(',')
          .map((id) => Number(id))
          .filter(Boolean);
        if (!ids.length || button.disabled) return;

        const label = button.querySelector('[data-daluca-bundle-label]');
        const upsellRoot = button.closest('.daluca-pdp-upsells');
        const message = upsellRoot ? upsellRoot.querySelector('[data-daluca-bundle-message]') : null;
        const originalLabel = label ? window.DaLucaI18n.sourceText(label) : '';
        button.disabled = true;
        button.classList.add('is-loading');
        button.setAttribute('aria-busy', 'true');
        if (label) window.DaLucaI18n.setText(label, 'Adding…');
        if (message) message.hidden = true;

        fetch((window.theme && theme.routes && theme.routes.cart_add_url) || '/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({ items: ids.map((id) => ({ id: id, quantity: 1 })) })
        })
          .then((response) => {
            if (!response.ok) return response.json().then((data) => Promise.reject(data));
            return response.json();
          })
          .then((response) => {
            document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            document.dispatchEvent(new CustomEvent('cart:item-added', {
              bubbles: true,
              detail: { product: response.items && response.items[0] ? response.items[0] : response }
            }));
            if (message) {
              window.DaLucaI18n.setText(message, 'All three care and installation essentials were added to your cart.');
              message.hidden = false;
            }
            trackEvent('daluca_pdp_addition_added', {
              addition_name: String(button.dataset.dalucaUpsellName || 'Leather Care Set'),
              item_count: ids.length
            });
            window.setTimeout(() => {
              const drawer = document.querySelector('cart-drawer');
              if (drawer && typeof drawer.open === 'function') drawer.open();
            }, 250);
          })
          .catch((error) => {
            if (message) {
              window.DaLucaI18n.setText(message, (error && (error.description || error.message)) || 'One of the additions could not be added. Please use the individual Add buttons.');
              message.hidden = false;
            }
          })
          .finally(() => {
            button.disabled = false;
            button.classList.remove('is-loading');
            button.removeAttribute('aria-busy');
            if (label) window.DaLucaI18n.setText(label, originalLabel);
          });
      });
    });
  }

  function normalizeText(value) {
    return String(value || '').replace(/\s+/g, ' ').trim();
  }

  function findHowToBlock(label) {
    const known = new Set([
      'WIDTH','LENGTH','BUCKLE TYPE','STITCHING TYPE',
      'STITCHING COLOR','KEEPER','VENETIAN CREAM','DETAILS'
    ]);
    const heading = Array.from(document.querySelectorAll('h2,h3,h4')).find(h => {
      if (h.closest('.daluca-custom-consolidated-builder,.daluca-custom-order-guide--rollout,.daluca-process-panel-v32')) return false;
      return normalizeText(window.DaLucaI18n.sourceText(h)).toUpperCase() === label.toUpperCase();
    });
    if (!heading) return null;

    let node = heading.parentElement;
    let chosen = node;
    for (let i = 0; i < 5 && node && node !== document.body; i += 1, node = node.parentElement) {
      const labels = Array.from(node.querySelectorAll('h2,h3,h4'))
        .map(h => normalizeText(window.DaLucaI18n.sourceText(h)).toUpperCase())
        .filter(text => known.has(text));
      if (node.querySelector('img,p,table') && labels.length <= 1) chosen = node;
      if (labels.length > 1) break;
    }
    if (!chosen) return null;

    const clone = chosen.cloneNode(true);
    clone.classList.add('daluca-process-detail-v32');
    clone.querySelectorAll('[id]').forEach(el => el.removeAttribute('id'));
    clone.querySelectorAll('script,style,form,input,select,textarea,button').forEach(el => el.remove());
    return { source: chosen, clone };
  }

  function fallbackProcessCard(title, text) {
    const card = document.createElement('article');
    card.className = 'daluca-process-detail-v32 daluca-process-detail-v32--fallback';
    const h = document.createElement('h4');
    window.DaLucaI18n.setText(h, title);
    const p = document.createElement('p');
    window.DaLucaI18n.setText(p, text);
    card.append(h, p);
    return card;
  }

  function initProcessGuide() {
    const guide = document.querySelector('.daluca-custom-order-guide--rollout');
    if (!guide || guide.dataset.dalucaProcessV32 === '1') return;
    const stepsWrap = guide.querySelector('.daluca-custom-order-guide__steps');
    const steps = Array.from(guide.querySelectorAll('.daluca-custom-order-guide__step'));
    if (!stepsWrap || steps.length !== 6) return;

    const maps = [
      { title: 'Fit & Size', labels: ['WIDTH','LENGTH'] },
      { title: 'Leather & Construction', labels: [], fallback: ['Leather & Thickness','Choose the leather, color and construction options in the builder above.'] },
      // The approved custom template uses the dedicated STITCHING COLOR card
      // here. Keep it as one centered detail instead of adding an extra generic
      // finishing card beside it.
      { title: 'Stitching Color', labels: ['STITCHING COLOR'], fallback: ['Stitching Color','Choose your thread color in the builder above.'] },
      { title: 'Hardware', labels: ['BUCKLE TYPE','KEEPER'] },
      { title: 'Care & Details', labels: ['VENETIAN CREAM','DETAILS'] },
      { title: 'Built By Hand', labels: [], fallback: ['Made to order','Once your configuration is complete, your strap is built by hand in our San Diego workshop. Production timing follows the option selected above.'] }
    ];

    const panel = document.createElement('div');
    panel.className = 'daluca-process-panel-v32';
    const sections = [];
    const sourcesToHide = [];

    maps.forEach((map, index) => {
      const section = document.createElement('section');
      section.className = 'daluca-process-panel-v32__section';
      section.hidden = index !== 0;

      const head = document.createElement('div');
      head.className = 'daluca-process-panel-v32__head';
      const number = document.createElement('span');
      window.DaLucaI18n.setText(number, '0' + (index + 1));
      const title = document.createElement('h3');
      window.DaLucaI18n.setText(title, map.title);
      head.append(number, title);
      section.appendChild(head);

      const grid = document.createElement('div');
      grid.className = 'daluca-process-panel-v32__grid';
      map.labels.forEach(label => {
        const found = findHowToBlock(label);
        if (!found) return;
        grid.appendChild(found.clone);
        sourcesToHide.push(found.source);
      });
      if (map.fallback && !grid.children.length) grid.appendChild(fallbackProcessCard(map.fallback[0], map.fallback[1]));
      if (!grid.children.length) grid.appendChild(fallbackProcessCard(map.title, 'Use the corresponding controls in the custom builder above to configure this part of your strap.'));
      section.appendChild(grid);
      panel.appendChild(section);
      sections.push(section);
    });

    stepsWrap.insertAdjacentElement('afterend', panel);
    steps.forEach((step, index) => {
      step.classList.add('daluca-process-step-v32');
      step.setAttribute('role', 'button');
      step.setAttribute('tabindex', '0');
      step.setAttribute('aria-expanded', index === 0 ? 'true' : 'false');

      const icon = step.querySelector('.daluca-custom-order-guide__icon');
      if (icon) {
        const mark = document.createElement('span');
        mark.className = 'daluca-process-step-v32__mark';
        window.DaLucaI18n.setText(mark, index === 0 ? '−' : '+');
        icon.appendChild(mark);
      }

      const activate = () => {
        steps.forEach((other, i) => {
          const active = i === index;
          other.classList.toggle('is-active', active);
          other.setAttribute('aria-expanded', active ? 'true' : 'false');
          sections[i].hidden = !active;
          const mark = other.querySelector('.daluca-process-step-v32__mark');
          if (mark) window.DaLucaI18n.setText(mark, active ? '−' : '+');
        });
      };
      step.addEventListener('click', activate);
      step.addEventListener('keydown', event => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          activate();
        }
      });
      if (index === 0) step.classList.add('is-active');
    });

    Array.from(new Set(sourcesToHide)).forEach(source => {
      if (source.closest('.daluca-custom-consolidated-builder,.daluca-custom-order-guide--rollout')) return;
      source.classList.add('daluca-howto-source-v32-hidden');
    });

    const oldTitle = Array.from(document.querySelectorAll('h1,h2,h3')).find(h => {
      const text = normalizeText(window.DaLucaI18n.sourceText(h));
      return /customizing your watch band/i.test(text) && /how to order/i.test(text) && !h.closest('.daluca-custom-order-guide--rollout');
    });
    if (oldTitle) oldTitle.classList.add('daluca-howto-source-v32-hidden');

    guide.dataset.dalucaProcessV32 = '1';
  }

  // Expose the guide initializer to the isolated consolidated runtime.
  // The two runtimes intentionally live in separate IIFEs.
  window.__dalucaInitProcessGuideV32 = initProcessGuide;

  function init() {
    document.querySelectorAll('[data-daluca-pdp-fit]').forEach(initFitChecker);
    initSecondColorLinks();
    initGalleryCounters();
    initGalleryNavigation();
    initGalleryHoverZoom();
    initProductStory();
    initQuickReleaseUpgrade();
    initPriceInAddButton();
    initProductDescriptions();
    initReviewVisibility();
    initBundleButtons();
    initMerchandisingTracking();
  }

  function watchDynamicProductContent() {
    if (!document.body || document.documentElement.dataset.dalucaDynamicReady === 'true') return;
    document.documentElement.dataset.dalucaDynamicReady = 'true';
    let queued = false;
    new MutationObserver(() => {
      if (queued) return;
      queued = true;
      window.requestAnimationFrame(() => {
        queued = false;
        init();
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      init();
      watchDynamicProductContent();
    }, { once: true });
  } else {
    init();
    watchDynamicProductContent();
  }

  document.addEventListener('shopify:section:load', init);
})();

/* =====================================================================
   DALUCA CUSTOM CORE V3 — CONSOLIDATED STRAP RUNTIME
   One authority for the 11 made-to-order watch strap PDPs.
   Native Globo controls remain in their original DOM positions.
   The visual builder is a proxy layer that dispatches to native controls.
   ===================================================================== */
(function () {
  'use strict';

  const BUILD = 'custom-master-v3-49-2026-09-22';
  window.__dalucaCustomConsolidatedBuild = BUILD;
  window.__dalucaCustomRuntimeErrors = window.__dalucaCustomRuntimeErrors || [];
  window.addEventListener('error', event => {
    window.__dalucaCustomRuntimeErrors.push(clean(event.message || 'JavaScript error'));
  });
  window.addEventListener('unhandledrejection', event => {
    window.__dalucaCustomRuntimeErrors.push(clean(event.reason?.message || event.reason || 'Unhandled promise rejection'));
  });

  const ROOT_SELECTOR = '.daluca-pdp--custom[data-daluca-consolidated-custom="true"]';
  const NATIVE_CONTROL_SELECTOR = 'select,textarea,input:not([type="hidden"]),button[data-field-name]';

  const SECTION_DEFS = {
    fit: { number: '01', title: 'Fit & Size', description: 'Set the dimensions and strap format for your watch.' },
    leather: { number: '02', title: 'Leather & Construction', description: 'Choose the material, color and construction choices offered for this strap.' },
    stitching: { number: '03', title: 'Stitching & Edges', description: 'Choose the stitching and edge finish.' },
    hardware: { number: '04', title: 'Hardware', description: 'Choose the buckle, keeper and related hardware.' },
    extras: { number: '05', title: 'Delivery, Care & Extras', description: 'Choose production timing and any optional care or installation extras.' },
    details: { number: '06', title: 'Details', description: 'Add any useful notes for the DaLuca workshop.' },
    additional: { number: '+', title: 'Additional Options', description: 'Product-specific choices supplied by the native customizer.' }
  };


  // Match the approved Custom Leather Strap option references so the shared
  // builder, summary and care row all speak the same visual language.
  const OPTION_REFS = {
    'Lug Width': 'A',
    'Taper': 'B',
    'Short Strap Length': 'C',
    'Long Strap Length': 'D',
    'Strap Length': 'C',
    'Wrist Size': 'C',
    'Thickness': 'E',
    'Leather Color': 'F',
    'Color': 'F',
    'Texture': 'F',
    'Lizard Color': 'F',
    'Alligator Color': 'F',
    'Shell Cordovan Color': 'F',
    'Leather': 'F',
    'Material': 'F',
    '74': 'F',
    'Stitching': 'G',
    'Stitching Type': 'G',
    'Stitching Color': 'H',
    'Thread Color': 'H',
    'Edge Coating': 'I',
    'Edge Finish': 'I',
    'Buckle': 'J',
    'Buckle (Odd)': 'J',
    'Buckle (Even)': 'J',
    'Buckle 14mm-22mm': 'J',
    'Buckle 24mm-26mm': 'J',
    'Buckle 27mm-28mm': 'J',
    'Keeper': 'K',
    'O-Ring': 'K',
    'O Ring': 'K',
    'Production Time': 'L',
    'Venetian Cream': 'M',
    'Care & Installation': 'M',
    'Quick Release': 'M',
    'Spring Bars': 'M',
    'Spring Bar Tool': 'M',
    'Details/Notes': 'N',
    'Details / Notes': 'N',
    'Details': 'N',
    'Notes': 'N',
    'Special Instructions': 'N'
  };

  const FIELD_META = {
    'Lug Width': { section: 'fit', label: 'Lug Width', help: 'Choose the exact lug width of your watch. We do not round odd widths.' },
    'Strap Style': { section: 'fit', label: 'Strap Style' },
    'Taper': { section: 'fit', label: 'Taper', help: 'Taper is the change from lug width to buckle width.' },
    'Short Strap Length': { section: 'fit', label: 'Short Strap Length (Buckle Strap)' },
    'Long Strap Length': { section: 'fit', label: 'Long Strap Length (Tip + Holes)' },
    'Strap Length': { section: 'fit', label: 'Strap Length' },
    'Wrist Size': { section: 'fit', label: 'Wrist Size' },
    'Thickness': { section: 'fit', label: 'Thickness' },

    'Leather Color': { section: 'leather', label: 'Leather Color' },
    'Color': { section: 'leather', label: 'Color' },
    '74': { section: 'leather', label: '“74” marking', help: 'Choose whether we add “74” to the short strap. Your selection appears in the live preview.' },
    'Texture': { section: 'leather', label: 'Texture' },
    'Lizard Color': { section: 'leather', label: 'Lizard Color' },
    'Alligator Color': { section: 'leather', label: 'Alligator Color' },
    'Shell Cordovan Color': { section: 'leather', label: 'Shell Cordovan Color' },
    'Leather': { section: 'leather', label: 'Leather' },
    'Material': { section: 'leather', label: 'Material' },

    'Stitching': { section: 'stitching', label: 'Stitching Type' },
    'Stitching Type': { section: 'stitching', label: 'Stitching Type' },
    'Stitching Color': { section: 'stitching', label: 'Stitching Color' },
    'Thread Color': { section: 'stitching', label: 'Thread Color' },
    'Edge Coating': { section: 'stitching', label: 'Edge Coating' },
    'Edge Finish': { section: 'stitching', label: 'Edge Finish' },

    'Buckle': { section: 'hardware', label: 'Buckle' },
    'Buckle (Odd)': { section: 'hardware', label: 'Buckle' },
    'Buckle (Even)': { section: 'hardware', label: 'Buckle' },
    'Buckle 14mm-22mm': { section: 'hardware', label: 'Buckle' },
    'Buckle 24mm-26mm': { section: 'hardware', label: 'Buckle' },
    'Buckle 27mm-28mm': { section: 'hardware', label: 'Buckle' },
    'Keeper': { section: 'extras', label: 'Keeper', help: 'Keepers are the loops that hold the free end of the strap.' },
    'O-Ring': { section: 'hardware', label: 'O-Ring' },
    'O Ring': { section: 'hardware', label: 'O-Ring' },

    'Production Time': { section: 'extras', label: 'Production Time' },
    'Venetian Cream': { section: 'extras', label: 'Venetian Cream' },
    'Care & Installation': { section: 'extras', label: 'Care & Installation' },
    'Quick Release': { section: 'hardware', label: 'Quick Release', help: 'Use your existing bars, or choose the quick-release option offered for this build. Confirm compatibility with your watch.' },
    'Spring Bars': { section: 'extras', label: 'Spring Bars' },
    'Spring Bar Tool': { section: 'extras', label: 'Spring Bar Tool' },

    'Details/Notes': { section: 'details', label: 'Details / Notes' },
    'Details / Notes': { section: 'details', label: 'Details / Notes' },
    'Details': { section: 'details', label: 'Details' },
    'Notes': { section: 'details', label: 'Notes' },
    'Special Instructions': { section: 'details', label: 'Special Instructions' }
  };

  const ALIASES = {
    'Short Length': 'Short Strap Length',
    'Long Length': 'Long Strap Length',
    'Short Strap Length (Buckle Strap)': 'Short Strap Length',
    'Long Strap Length (w/Tip + Holes)': 'Long Strap Length',
    'Long Strap Length (Tip + Holes)': 'Long Strap Length',
    'Stitching Type': 'Stitching',
    'Thread Colour': 'Thread Color',
    'Stitching Colour': 'Stitching Color',
    'Leather Colour': 'Leather Color',
    'Details / Notes': 'Details/Notes',
    'O Ring': 'O-Ring',
    'Production Lead Time': 'Production Time',
    'Lead Time': 'Production Time'
  };

  const COMPACT_VISUAL_FIELDS = new Set([
    'Leather Color','Shell Cordovan Color','Lizard Color','Alligator Color',
    'Color','Stitching Color','Edge Coating'
  ]);

  const COMMON_TWO_PIECE = [
    'Lug Width','Taper','Short Strap Length','Long Strap Length','Thickness',
    'Leather Color','Stitching','Stitching Color','Edge Coating','Buckle','Quick Release','Keeper',
    'Production Time','Care & Installation','Details/Notes'
  ];

  const COMMON_MILITARY = [
    'Lug Width','Strap Style','Taper','Short Strap Length','Long Strap Length','Strap Length','Thickness',
    'Leather Color','Color','Texture','Stitching','Stitching Color','Edge Coating',
    'Buckle','Buckle (Odd)','Buckle (Even)','Quick Release','Keeper','O-Ring',
    'Production Time','Care & Installation','Details/Notes'
  ];

  /* V3.49 custom master architecture. Two family definitions own the
     shared field order; each product entry contains only its true exceptions. */
  const FAMILY_FIELDS = {
    'two-piece': COMMON_TWO_PIECE,
    'military': COMMON_MILITARY
  };

  const PRODUCT_CONFIG = {
    'custom-leather-watch-strap': { family: 'two-piece', extras: [], required: ['Lug Width','Production Time','Quick Release'] },
    'the-74-vintage-leather-watch-strap': {
      family: 'two-piece',
      extras: ['Color','74','Buckle 14mm-22mm','Buckle 24mm-26mm','Buckle 27mm-28mm'],
      required: ['Lug Width','Production Time'],
      labels: { '74': '“74” marking' }
    },
    'custom-leather-military-watch-strap': { family: 'military', extras: [], required: ['Lug Width','Strap Style','Production Time'] },
    'shell-cordovan-military-watch-strap': { family: 'military', extras: ['Shell Cordovan Color'], required: ['Lug Width','Strap Style','Production Time'] },
    'vintage-french-ammo-military-watch-strap': { family: 'military', extras: ['Color','Texture'], required: ['Lug Width','Strap Style','Production Time'] },
    'vintage-french-ammo-watch-strap-black': { family: 'two-piece', extras: ['Texture'], required: ['Lug Width','Production Time'] },
    'handmade-lizard-watch-strap': { family: 'two-piece', extras: ['Lizard Color'], required: ['Lug Width','Production Time','Lizard Color'] },
    'shell-cordovan-watch-strap': { family: 'two-piece', extras: ['Shell Cordovan Color','Color'], required: ['Lug Width','Production Time'] },
    'handmade-alligator-watch-strap': { family: 'two-piece', extras: ['Alligator Color'], required: ['Lug Width','Production Time','Alligator Color'] },
    'vintage-french-ammo-watch-strap': { family: 'two-piece', extras: ['Color','Texture'], required: ['Lug Width','Production Time'] },
    'vintage-swiss-ammo-watch-strap': { family: 'two-piece', extras: ['Color','Texture'], required: ['Lug Width','Production Time'] }
  };

  function profileForHandle(productHandle) {
    const config = PRODUCT_CONFIG[productHandle];
    if (!config) return null;
    const base = FAMILY_FIELDS[config.family] || COMMON_TWO_PIECE;
    return {
      family: config.family,
      fields: base.concat(config.extras || []),
      required: (config.required || []).slice(),
      labels: config.labels || {}
    };
  }

  const PROFILES = Object.keys(PRODUCT_CONFIG).reduce((out, productHandle) => {
    out[productHandle] = profileForHandle(productHandle);
    return out;
  }, {});

  function clean(value) {
    return String(value == null ? '' : value).replace(/\*/g, '').replace(/\s+/g, ' ').trim();
  }

  function stripPropertyName(value) {
    let name = clean(value);
    const propertyMatch = name.match(/^properties\[(.*)\]$/i);
    if (propertyMatch) name = clean(propertyMatch[1]);
    name = name.replace(/\s+\d+$/, '');
    return ALIASES[name] || name;
  }

  function root() {
    return document.querySelector(ROOT_SELECTOR);
  }

  function handle() {
    return root()?.getAttribute('data-handle') || '';
  }

  function activeProfile() {
    return PROFILES[handle()] || null;
  }

  function getAppRoot(r) {
    if (!r) return null;
    const candidates = Array.from(r.querySelectorAll('.gpo-container,.gpo-app,[class*="gpo-container"],[id*="gpo"],[class*="globo"]'));
    return candidates.find(el => el.querySelector(NATIVE_CONTROL_SELECTOR)) || null;
  }

  function controlFieldName(control, app) {
    if (!control) return '';
    const dataName = stripPropertyName(control.getAttribute('data-field-name') || control.getAttribute('data-name') || '');
    if (dataName) return dataName;

    const nativeName = clean(control.getAttribute('name') || '');
    if (/^properties\[.+\]$/i.test(nativeName)) return stripPropertyName(nativeName);

    let node = control;
    for (let i = 0; i < 7 && node && node !== app; i += 1, node = node.parentElement) {
      const label = node.querySelector?.(':scope > .gpo-label .label-content,:scope > .gpo-label,:scope > legend,:scope > label');
      const text = stripPropertyName(window.DaLucaI18n.chainText(() => (label), [{kind:"text", optional:true}]) || '');
      if (text) return text;
    }
    return '';
  }

  function canonicalName(raw) {
    const stripped = stripPropertyName(raw);
    return ALIASES[stripped] || stripped;
  }

  function fieldContainerForControl(control, fieldName, app) {
    let node = control.closest('.gpo-element,[class*="gpo-element"]') || control.parentElement;
    let best = node;
    for (let i = 0; i < 6 && node && node !== app; i += 1, node = node.parentElement) {
      const controls = Array.from(node.querySelectorAll?.(NATIVE_CONTROL_SELECTOR) || []).filter(c => c.type !== 'hidden');
      if (!controls.length) continue;
      const names = new Set(controls.map(c => canonicalName(controlFieldName(c, app))).filter(Boolean));
      if (names.size === 1 && names.has(fieldName)) best = node;
      else if (names.size > 1) break;
    }
    return best || control.parentElement;
  }


  function controlContextText(control, container) {
    const values = [];
    if (control) {
      values.push(control.getAttribute?.('data-field-name') || '');
      values.push(control.getAttribute?.('name') || '');
      values.push(control.value || '');
      if (control.tagName === 'SELECT') {
        Array.from(control.options || []).forEach(option => values.push(window.DaLucaI18n.sourceText(option) || '', option.value || ''));
      }
    }
    if (container) values.push(window.DaLucaI18n.sourceText(container) || '');
    return clean(values.join(' '));
  }

  function classifyGenericField(rawName, control, container) {
    const raw = clean(rawName);
    const rawKey = raw.toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
    const context = controlContextText(control, container).toLowerCase();
    const generic = /^(?:add ons?|addons?|select(?:\s*\d+)?|option(?:\s*\d+)?|dropdown(?:\s*\d+)?)$/.test(rawKey);
    if (!generic) return '';

    if (/production|priority|lead\s*time|business\s*days?|weeks?|ship\s*within|expedite/.test(context)) return 'Production Time';
    if (/venetian\s*cream|leather\s*cream|conditioner/.test(context)) return 'Venetian Cream';
    if (/keeper/.test(context)) return 'Keeper';
    if (/buckle/.test(context)) return 'Buckle';
    if (/stitch|thread/.test(context)) return /color|colour/.test(context) ? 'Stitching Color' : 'Stitching';
    if (/edge/.test(context)) return 'Edge Coating';
    if (/detail|note|special\s*instruction/.test(context)) return 'Details/Notes';
    return '';
  }

  function nativeVisible(field) {
    return field.containers.some(container => {
      if (!container) return false;
      let node = container;
      while (node && node !== field.app?.parentElement) {
        if (node.hidden || node.getAttribute?.('aria-hidden') === 'true') return false;
        const style = getComputedStyle(node);
        if (style.display === 'none' || style.visibility === 'hidden') return false;
        if (node === field.app) break;
        node = node.parentElement;
      }
      return true;
    });
  }

  function nativeRequired(field) {
    if (field.controls.some(control => control.required || control.getAttribute('aria-required') === 'true' || control.hasAttribute('presence'))) return true;
    return field.containers.some(container => /\*/.test(window.DaLucaI18n.chainText(() => (container), [{kind:"member", optional:false, computed:false, key: () => ("querySelector")}, {kind:"call", optional:false, args: () => ['.gpo-label,legend']}, {kind:"text", optional:true}]) || ''));
  }

  function collectFields(app, profileDef) {
    const map = new Map();
    const controls = Array.from(app.querySelectorAll(NATIVE_CONTROL_SELECTOR)).filter(control => {
      if (control.type === 'hidden') return false;
      if (control.matches('button[type="submit"],button[name="add"]')) return false;
      return true;
    });

    controls.forEach(control => {
      const raw = controlFieldName(control, app);
      if (!raw) return;
      const provisional = canonicalName(raw);
      const provisionalContainer = fieldContainerForControl(control, provisional || raw, app);
      const name = classifyGenericField(raw, control, provisionalContainer) || provisional;
      if (!name) return;
      if (!map.has(name)) map.set(name, { name, rawNames: new Set(), controls: [], containers: new Set() });
      const field = map.get(name);
      field.rawNames.add(raw);
      field.controls.push(control);
      field.containers.add(fieldContainerForControl(control, name, app));
    });

    return Array.from(map.values()).map(field => {
      field.containers = Array.from(field.containers).filter(Boolean);
      field.app = app;
      field.isExpected = profileDef.fields.includes(field.name);
      field.meta = FIELD_META[field.name] || { section: 'additional', label: field.name };
      field.displayLabel = profileDef.labels[field.name] || field.meta.label || field.name;
      field.required = nativeRequired(field) || profileDef.required.includes(field.name);
      return field;
    });
  }

  function directVenetianFieldContainer(control, app) {
    if (!control) return null;
    const explicit = control.closest('.gpo-element,[data-gpo-element]');
    if (explicit) return explicit;
    const dataName = clean(control.getAttribute?.('data-field-name') || '');
    const name = clean(control.name || '');
    const id = clean(control.id || '');
    const aria = clean(control.getAttribute?.('aria-label') || '');
    if (/venetian\s*cream/i.test([dataName, name, id, aria].join(' '))) return control.parentElement || app;
    return null;
  }

  function forceLegacyVenetianOff(state) {
    const app = state?.app;
    if (!app) return false;
    const containers = new Set();

    Array.from(app.querySelectorAll('select,input,textarea')).forEach(control => {
      // Never treat Globo's internal serialized payload inputs as the Venetian field.
      if (/properties\[_gpo_/i.test(String(control.name || ''))) return;
      const container = directVenetianFieldContainer(control, app);
      if (!container) return;
      const context = [
        control.getAttribute?.('data-field-name'), control.name, control.id, control.getAttribute?.('aria-label'),
        window.DaLucaI18n.chainText(() => (container), [{kind:"member", optional:false, computed:false, key: () => ("querySelector")}, {kind:"call", optional:true, args: () => ['.gpo-label,label,[class*="label"]']}, {kind:"text", optional:true}]),
        container.matches?.('.gpo-element,[data-gpo-element]') ? window.DaLucaI18n.sourceText(container) : ''
      ].filter(Boolean).join(' ');
      if (/venetian\s*cream/i.test(context)) containers.add(container);
    });

    let changed = false;
    containers.forEach(container => {
      const select = container.querySelector('select');
      if (select) {
        const options = Array.from(select.options || []);
        const noOption = options.find(option => /^(?:no|none|without|skip|no\s*thanks)\b/i.test(clean(window.DaLucaI18n.sourceText(option) || option.value)))
          || options.find(option => {
            const text = clean(window.DaLucaI18n.sourceText(option) || option.value);
            return text && !/please\s*select|^--/i.test(text) && !/\+\s*\$|yes|add\b/i.test(text);
          });
        if (noOption && select.value !== noOption.value) {
          select.value = noOption.value;
          noOption.selected = true;
          changed = true;
          select.dispatchEvent(new Event('input', { bubbles: true }));
          select.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }

      const radios = Array.from(container.querySelectorAll('input[type="radio"]'));
      if (radios.length) {
        const noRadio = radios.find(input => {
          const label = input.id ? document.querySelector('label[for="' + CSS.escape(input.id) + '"]') : input.closest('label');
          return /^(?:no|none|without|skip|no\s*thanks)\b/i.test(clean(window.DaLucaI18n.chainText(() => (label), [{kind:"text", optional:true}]) || input.value));
        });
        if (noRadio && !noRadio.checked) {
          noRadio.checked = true;
          changed = true;
          noRadio.dispatchEvent(new Event('input', { bubbles: true }));
          noRadio.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }

      container.querySelectorAll('input[type="checkbox"]').forEach(input => {
        if (input.checked) {
          input.checked = false;
          changed = true;
          input.dispatchEvent(new Event('input', { bubbles: true }));
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });

      container.querySelectorAll('input,select,textarea').forEach(control => {
        if (/properties\[_gpo_/i.test(String(control.name || ''))) return;
        control.required = false;
        control.removeAttribute('required');
        control.setAttribute('aria-required', 'false');
      });
    });

    if (changed) state.legacyVenetianForcedOff = true;
    return changed;
  }

  function legacyCareNoSelected(control) {
    if (!control) return false;
    const value = control.tagName === 'SELECT' ? window.DaLucaI18n.chainText(() => (control), [{kind:"member", optional:false, computed:false, key: () => ("options")}, {kind:"member", optional:true, computed:true, key: () => (control.selectedIndex)}, {kind:"text", optional:true}]) || control.value : control.value;
    const selected = control.tagName === 'SELECT' || control.type === 'hidden' || (control.type === 'radio' && control.checked);
    return selected && /^(?:no|none|without|skip)\b/i.test(clean(value));
  }

  function hardRetireLegacyVenetianDom(state) {
    const app = state?.app;
    if (!app) return false;

    // First satisfy the legacy required option with its zero-cost NO choice so
    // Globo's own internal state is valid. The visible DaLuca care cards are
    // separate products and remain the only shopper-facing care controls.
    forceLegacyVenetianOff(state);

    let retired = false;
    Array.from(app.querySelectorAll('input,select,textarea')).forEach(control => {
      // These three inputs carry every legitimate Globo selection and surcharge.
      // They must remain enabled or the configured strap loses its paid options.
      if (/properties\[_gpo_(?:options|addon_products|product_group)\]/i.test(String(control.name || ''))) return;

      const container = directVenetianFieldContainer(control, app);
      if (!container) return;
      const context = [
        control.getAttribute?.('data-field-name'), control.name, control.id, control.getAttribute?.('aria-label'),
        window.DaLucaI18n.chainText(() => (container), [{kind:"member", optional:false, computed:false, key: () => ("querySelector")}, {kind:"call", optional:true, args: () => ['.gpo-label,label,[class*="label"]']}, {kind:"text", optional:true}]),
        container.matches?.('.gpo-element,[data-gpo-element]') ? window.DaLucaI18n.sourceText(container) : ''
      ].filter(Boolean).join(' ');
      if (!/venetian\s*cream/i.test(context)) return;

      retired = true;
      control.required = false;
      control.removeAttribute('required');
      control.setAttribute('aria-required', 'false');
      // Keep a selected NO radio/select enabled long enough for Globo to serialize
      // it. Everything else in the retired field can be disabled safely.
      const disabled = !legacyCareNoSelected(control);
      if (control.disabled !== disabled) control.disabled = disabled;
      control.setAttribute('data-daluca-retired-care-control', 'true');

      if (container) {
        if (!container.classList.contains('daluca-retired-legacy-care-field')) container.classList.add('daluca-retired-legacy-care-field');
        if (container.getAttribute('aria-hidden') !== 'true') container.setAttribute('aria-hidden', 'true');
        ['required','data-required','data-gpo-required','data-is-required'].forEach(attr => container.removeAttribute(attr));
        if (['required','is-required','gpo-required','has-error','error'].some(name => container.classList.contains(name))) {
          container.classList.remove('required','is-required','gpo-required','has-error','error');
        }
      }
    });
    if (retired) state.legacyVenetianRetired = true;
    return retired;
  }

  function neutralizeLegacyVenetianCream(state, fields) {
    const list = fields || [];
    if (!state?.root || !state?.app) return list;
    forceLegacyVenetianOff(state);
    hardRetireLegacyVenetianDom(state);

    // V3.35 hard rule: the visible Care & Installation product cards are the
    // only Venetian Cream UI on consolidated custom straps. The old Globo
    // Venetian Cream field is therefore always retired when it exists, even
    // before the visible care cards have been moved into Box 05.
    let retired = false;
    list.forEach(field => {
      if (field?.name !== 'Venetian Cream') return;
      retired = true;
      field.isExpected = false;
      field.required = false;
      (field.controls || []).forEach(control => {
        if (!control) return;
        if (/^(checkbox|radio)$/i.test(control.type || '') && !legacyCareNoSelected(control)) control.checked = false;
        control.required = false;
        control.removeAttribute('required');
        control.setAttribute('aria-required', 'false');
        const disabled = !legacyCareNoSelected(control);
        if (control.disabled !== disabled) control.disabled = disabled;
        control.setAttribute('data-daluca-retired-care-control', 'true');
      });
      (field.containers || []).forEach(container => {
        if (!container) return;
        if (!container.classList.contains('daluca-retired-legacy-care-field')) container.classList.add('daluca-retired-legacy-care-field');
        if (container.getAttribute('aria-hidden') !== 'true') container.setAttribute('aria-hidden', 'true');
        ['required','data-required','data-gpo-required','data-is-required'].forEach(attr => container.removeAttribute(attr));
        if (['required','is-required','gpo-required','has-error','error'].some(name => container.classList.contains(name))) {
          container.classList.remove('required','is-required','gpo-required','has-error','error');
        }
        container.querySelectorAll('[required]').forEach(node => {
          node.required = false;
          node.removeAttribute('required');
        });
        container.querySelectorAll('[aria-required="true"]').forEach(node => node.setAttribute('aria-required', 'false'));
      });
    });
    state.legacyVenetianRetired = retired;
    return list;
  }

  function optionText(input) {
    if (!input) return '';
    const id = input.id;
    const labelled = id ? document.querySelector('label[for="' + CSS.escape(id) + '"]') : null;
    const choice = input.closest('label,.gpo-swatches,.gpo-ov-item,[role="radio"],[role="option"]');
    const title = choice?.querySelector?.('.gpo-swatch__title,.gpo-ov-item-title,.gpo-ov-title,[class*="title"]');
    let text = clean(window.DaLucaI18n.chainText(() => (title), [{kind:"text", optional:true}]) || window.DaLucaI18n.chainText(() => (labelled), [{kind:"text", optional:true}]) || window.DaLucaI18n.chainText(() => (choice), [{kind:"text", optional:true}]) || input.value || '');
    if (text.length > 180) text = clean(input.value || text.slice(0, 180));
    return text || clean(input.value) || 'Option';
  }


  function displayFieldValue(field, value) {
    if (field?.name === '74') {
      if (/^yes$/i.test(clean(value))) return 'Yes — add “74”';
      if (/^no$/i.test(clean(value))) return 'No — do not add “74”';
    }
    return value;
  }

  function displayChoiceText(field, input) {
    const full = displayFieldValue(field, optionText(input));
    if (field?.name === 'Strap Style') {
      if (/1\s*piece|one\s*piece/i.test(full)) return '1 Piece';
      if (/military/i.test(full)) return 'Military';
    }
    return full;
  }

  function optionVisual(input) {
    const choice = input.closest('label,.gpo-swatches,.gpo-ov-item,[role="radio"],[role="option"]') || input.parentElement;
    const img = choice?.querySelector?.('img');
    if (img) {
      const clone = img.cloneNode(true);
      clone.removeAttribute('id');
      clone.removeAttribute('loading');
      clone.setAttribute('aria-hidden', 'true');
      // Larger option tiles need the original Shopify source, not app thumbnails.
      try {
        const source = new URL(img.currentSrc || img.src, location.href);
        if (source.hostname === location.hostname || source.hostname === 'cdn.shopify.com') {
          source.searchParams.set('width', '320');
          clone.removeAttribute('srcset');
          clone.removeAttribute('data-srcset');
          clone.src = source.href;
        }
      } catch (_) {}
      return clone;
    }
    const visual = choice?.querySelector?.('.gpo-swatch__inner,[class*="swatch"]');
    if (visual) {
      const style = getComputedStyle(visual);
      const bg = style.backgroundColor;
      if (bg && bg !== 'rgba(0, 0, 0, 0)' && bg !== 'transparent') {
        const dot = document.createElement('span');
        dot.className = 'daluca-proxy-choice__color';
        dot.style.backgroundColor = bg;
        dot.setAttribute('aria-hidden', 'true');
        return dot;
      }
    }
    return null;
  }

  function setSelect(native, value) {
    if (!native || native.disabled) return;
    native.value = value;
    const match = Array.from(native.options || []).find(option => option.value === value);
    if (match) match.selected = true;
    native.dispatchEvent(new Event('input', { bubbles: true }));
    native.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function setText(native, value) {
    if (!native || native.disabled) return;
    const descriptor = Object.getOwnPropertyDescriptor(Object.getPrototypeOf(native), 'value');
    if (descriptor?.set) descriptor.set.call(native, value);
    else native.value = value;
    native.dispatchEvent(new Event('input', { bubbles: true }));
    native.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function markNativeProxied(field) {
    field.containers.forEach(container => {
      container.classList.add('daluca-native-proxied');
      container.setAttribute('data-daluca-native-field', field.name);
    });
  }

  function selectedValue(field) {
    const select = field.controls.find(control => control.tagName === 'SELECT');
    if (select) {
      const label = clean(window.DaLucaI18n.chainText(() => (select), [{kind:"member", optional:false, computed:false, key: () => ("options")}, {kind:"member", optional:true, computed:true, key: () => (select.selectedIndex)}, {kind:"text", optional:true}]) || select.value);
      if (!clean(select.value) || /^(?:--\s*)?(?:please\s+)?select(?:\s*--)?$/i.test(label)) return '';
      return label;
    }
    const checked = field.controls.filter(control => /radio|checkbox/i.test(control.type) && control.checked);
    if (checked.length) {
      const value = checked.map(optionText).join(', ');
      if (field.name === 'Strap Style') {
        if (/1\s*piece|one\s*piece/i.test(value)) return '1 Piece';
        if (/military/i.test(value)) return 'Military';
      }
      return value;
    }
    const text = field.controls.find(control => control.tagName === 'TEXTAREA' || ['text','number','search','email'].includes(control.type));
    return clean(text?.value || '');
  }

  function applyBuckleAvailability(state, fields) {
    const lugField = fields.find(field => field.name === 'Lug Width');
    const taperField = fields.find(field => field.name === 'Taper' && nativeVisible(field));
    const lug = parseFloat(lugField ? selectedValue(lugField) : '');
    const taperValue = taperField ? selectedValue(taperField) : 'No Taper';
    const taper = !taperValue || /^No Taper/i.test(taperValue) ? 0 : parseFloat(taperValue);
    const military = state.profile.family === 'military';
    const width = military ? lug : lug - taper;
    const allowed = value => {
      if (/^No Buckle/i.test(value)) return true;
      if (/Pre[\s-]*V\b/i.test(value)) return [22, 24, 26].includes(width);
      if (/\bARD\b/i.test(value) && ![18, 20, 22, 24, 26].includes(width)) return false;
      if (/\bINOX\b/i.test(value) && ![14, 16, 18, 20, 22, 24].includes(width)) return false;
      if (military && /bronze/i.test(value) && ![24, 26].includes(width)) return false;
      return true;
    };
    fields.filter(field => /^Buckle(?:\s|$|\()/i.test(field.name) || field.name === 'Keeper').forEach(field => {
      field.controls.forEach(control => {
        if (control.tagName === 'SELECT') {
          Array.from(control.options).forEach(option => {
            option.dataset.dalucaBuckleUnavailable = String(!allowed(option.value));
          });
          if (control.value && !allowed(control.value)) setSelect(control, '');
        } else if (/^(radio|checkbox)$/i.test(control.type)) {
          const unavailable = !allowed(control.value);
          control.dataset.dalucaBuckleUnavailable = String(unavailable);
          if (unavailable && control.checked) {
            control.checked = false;
            control.dispatchEvent(new Event('input', { bubbles: true }));
            control.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
      });
    });
  }

  function currentProxyNativeControl(state, original) {
    if (!state?.app || !original) return null;
    const candidates = original.id ? Array.from(state.app.querySelectorAll('[id]')).filter(control => control.id === original.id) : [original];
    if (candidates.length !== 1) return null;
    const control = candidates[0];
    if (!control.isConnected || !state.app.contains(control) || control.tagName !== original.tagName ||
        control.name !== original.name || control.type !== original.type) return null;
    if (/^(radio|checkbox)$/.test(control.type) && control.value !== original.value) return null;
    return control;
  }

  function makeField(field, state) {
    const wrap = document.createElement('div');
    wrap.className = 'daluca-proxy-field';
    wrap.dataset.dalucaProxyField = field.name;

    const heading = document.createElement('div');
    heading.className = 'daluca-proxy-field__heading';
    const label = document.createElement('div');
    label.className = 'daluca-proxy-field__label';
    const ref = document.createElement('span');
    ref.className = 'daluca-proxy-field__ref';
    ref.dataset.dalucaSequentialRef = 'true';
    window.DaLucaI18n.setText(ref, '');
    ref.setAttribute('aria-hidden', 'true');
    label.appendChild(ref);
    const labelText = document.createElement('span');
    labelText.className = 'daluca-proxy-field__label-text';
    window.DaLucaI18n.setText(labelText, field.displayLabel);
    label.appendChild(labelText);
    if (field.required) {
      const required = document.createElement('span');
      required.className = 'daluca-proxy-field__required';
      window.DaLucaI18n.setText(required, 'Required');
      label.appendChild(required);
    }
    heading.appendChild(label);
    if (field.meta.help) {
      const help = document.createElement('p');
      help.className = 'daluca-proxy-field__help';
      window.DaLucaI18n.setText(help, field.meta.help);
      heading.appendChild(help);
    }
    wrap.appendChild(heading);

    const select = field.controls.find(control => control.tagName === 'SELECT');
    const radios = field.controls.filter(control => /^(radio|checkbox)$/i.test(control.type));
    const text = field.controls.find(control => control.tagName === 'TEXTAREA' || ['text','number','search','email'].includes(control.type));
    const file = field.controls.find(control => control.type === 'file');

    if (select) {
      const proxy = document.createElement('select');
      proxy.className = 'daluca-proxy-select';
      proxy.setAttribute('aria-label', field.displayLabel);
      Array.from(select.options).forEach(option => {
        const clone = document.createElement('option');
        clone.value = option.value;
        const sourceLabel = clean(window.DaLucaI18n.sourceText(option));
        if (/\bcolou?r$/i.test(field.name)) {
          window.DaLucaI18n.setDisplayText(clone, sourceLabel, window.DaLucaI18n.displayText(sourceLabel));
        } else {
          window.DaLucaI18n.setText(clone, sourceLabel);
        }
        clone.disabled = option.disabled || option.dataset.dalucaBuckleUnavailable === 'true';
        clone.hidden = option.dataset.dalucaBuckleUnavailable === 'true';
        clone.selected = option.selected;
        proxy.appendChild(clone);
      });
      proxy.value = select.value;
      proxy.disabled = select.disabled;
      proxy.addEventListener('change', () => {
        const current = currentProxyNativeControl(state, select);
        const option = current && Array.from(current.options).find(option => option.value === proxy.value);
        if (option && !option.disabled && !option.hidden && option.dataset.dalucaBuckleUnavailable !== 'true') setSelect(current, proxy.value);
        queueSync(state, 20);
      });
      wrap.appendChild(proxy);
      markNativeProxied(field);
    } else if (radios.length) {
      const grid = document.createElement('div');
      grid.className = 'daluca-proxy-choice-grid';
      grid.setAttribute('role', 'group');
      grid.setAttribute('aria-label', field.displayLabel);
      let visualCount = 0;
      radios.forEach(input => {
        const choiceLabel = displayChoiceText(field, input);
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'daluca-proxy-choice';
        button.dataset.nativeId = input.id || '';
        button.disabled = input.disabled || input.dataset.dalucaBuckleUnavailable === 'true';
        if (input.dataset.dalucaBuckleUnavailable === 'true') button.style.setProperty('display', 'none', 'important');
        button.title = window.DaLucaI18n.displayText(field.name === '74' ? choiceLabel : (optionText(input) || choiceLabel));
        button.setAttribute('aria-label', window.DaLucaI18n.displayText(choiceLabel || field.displayLabel));
        button.setAttribute('aria-pressed', input.checked ? 'true' : 'false');
        if (input.checked) button.classList.add('is-selected');
        const visual = optionVisual(input);
        if (visual) {
          visualCount += 1;
          button.dataset.dalucaHasVisual = 'true';
          button.appendChild(visual);
        }
        const textSpan = document.createElement('span');
        textSpan.className = 'daluca-proxy-choice__text';
        window.DaLucaI18n.setText(textSpan, choiceLabel);
        button.appendChild(textSpan);
        button.addEventListener('click', () => {
          const current = currentProxyNativeControl(state, input);
          if (!current || current.disabled || current.dataset.dalucaBuckleUnavailable === 'true') return;
          current.click();
          queueSync(state, 20);
        });
        grid.appendChild(button);
      });
      if (COMPACT_VISUAL_FIELDS.has(field.name) && visualCount >= Math.max(2, Math.ceil(radios.length * 0.6))) {
        wrap.dataset.dalucaVisualGrid = 'true';
      }
      wrap.appendChild(grid);
      markNativeProxied(field);
    } else if (text) {
      const proxy = text.tagName === 'TEXTAREA' ? document.createElement('textarea') : document.createElement('input');
      if (proxy.tagName === 'INPUT') proxy.type = text.type === 'number' ? 'number' : 'text';
      proxy.className = 'daluca-proxy-text';
      proxy.value = text.value || '';
      proxy.placeholder = text.placeholder || '';
      proxy.disabled = text.disabled;
      proxy.setAttribute('aria-label', field.displayLabel);
      proxy.addEventListener('input', () => setText(currentProxyNativeControl(state, text), proxy.value));
      proxy.addEventListener('change', () => setText(currentProxyNativeControl(state, text), proxy.value));
      wrap.appendChild(proxy);
      markNativeProxied(field);
    } else if (file) {
      const note = document.createElement('p');
      note.className = 'daluca-proxy-field__native-note';
      window.DaLucaI18n.setText(note, 'Use the native upload control shown below for this option.');
      wrap.appendChild(note);
    } else {
      const note = document.createElement('p');
      note.className = 'daluca-proxy-field__native-note';
      window.DaLucaI18n.setText(note, 'This product-specific option remains in the native customizer below.');
      wrap.appendChild(note);
    }

    return wrap;
  }

  function sectionFor(field) {
    return FIELD_META[field.name]?.section || 'additional';
  }

  function orderedFields(fields, profileDef) {
    const order = new Map(profileDef.fields.map((name, index) => [name, index]));
    return fields.slice().sort((a, b) => {
      const ai = order.has(a.name) ? order.get(a.name) : 10000;
      const bi = order.has(b.name) ? order.get(b.name) : 10000;
      return ai - bi || a.name.localeCompare(b.name);
    });
  }


  function fitCheckerSource(state) {
    return state.root.querySelector('.daluca-concierge-step--fit [data-daluca-pdp-fit], [data-daluca-pdp-fit]');
  }

  function embedFitChecker(section, state) {
    if (!section || section.dataset.dalucaFitEmbedded === '1') return;
    const body = section.querySelector('.daluca-builder-section__body');
    const fit = fitCheckerSource(state);
    if (!body || !fit) return;

    const holder = document.createElement('div');
    holder.className = 'daluca-builder-fit-search';
    window.DaLucaI18n.setHtml(holder, '<strong>Not sure of your lug width?</strong><span>Search your watch, model, or reference</span>');
    holder.appendChild(fit);
    const fitInput = fit.querySelector('input[type="search"], input[type="text"]');
    if (fitInput) {
      fitInput.placeholder = 'Search your watch, model, or reference';
      fitInput.setAttribute('aria-label', 'Search your watch, model, or reference');
    }
    body.insertBefore(holder, body.firstChild);
    section.dataset.dalucaFitEmbedded = '1';

    const oldStep = state.root.querySelector('.daluca-concierge-step--fit');
    if (oldStep) oldStep.classList.add('daluca-consolidated-top-suppressed');
  }

  function findCareSource(state) {
    return state.root.querySelector('.daluca-pdp-upsells--essentials');
  }

  function careCard(care, pattern) {
    if (!care) return null;
    return Array.from(care.querySelectorAll('[data-daluca-upsell],product-card,.daluca-pdp-upsell')).find(card => pattern.test(clean(window.DaLucaI18n.sourceText(card) || ''))) || null;
  }

  function careOwner() { return document.querySelector('[data-daluca-visualizer]')?.dataset.productHandle || location.pathname.split('/products/')[1]?.split('/')[0] || ''; }
  function isOwnedCare(line) { return line.properties?.['_DaLuca care item'] === 'true' && !line.selling_plan_allocation; }

  async function removeOneCareVariant(variantId) {
    if (!variantId) return false;
    try {
      const rootUrl = (window.Shopify?.routes?.root || '/').replace(/\/?$/, '/');
      const cartResponse = await fetch(rootUrl + 'cart.js', { headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, cache: 'no-store' });
      if (!cartResponse.ok) throw new Error('Unable to read cart');
      const cart = await cartResponse.json();
      const item = (cart.items || []).find(line => String(line.variant_id || line.id) === String(variantId) && isOwnedCare(line));
      if (!item) return true;
      const response = await fetch(rootUrl + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        credentials: 'same-origin',
        body: JSON.stringify({ id: item.key || item.id, quantity: Math.max(0, (Number(item.quantity) || 1) - 1) })
      });
      const updated = await response.json();
      if (!response.ok || updated?.status) throw new Error(updated?.description || updated?.message || 'Unable to remove item');
      document.querySelectorAll('.thb-item-count').forEach(node => { window.DaLucaI18n.setText(node, Number(updated.item_count || 0) > 99 ? '*' : String(updated.item_count || 0)); });
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart: updated, source: 'daluca-custom-care' } }));
      document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: updated, source: 'daluca-custom-care' } }));
      return true;
    } catch (error) {
      console.error('[DaLuca consolidated care remove]', error);
      return false;
    }
  }

  async function updateCartSectionsSilently(response) {
    if (!response) return;
    [
      { id: 'Cart', section: 'main-cart', selector: '.thb-cart-form' },
      { id: 'Cart-Drawer', section: 'cart-drawer', selector: '.cart-drawer' },
      { id: 'cart-drawer-toggle', section: 'cart-bubble', selector: '.thb-item-count' }
    ].forEach(target => {
      const host = document.getElementById(target.id);
      const html = response.sections?.[target.section];
      if (!host || !html) return;
      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const replacement = parsed.querySelector(target.selector);
      const destination = host.querySelector(target.selector) || host;
      if (replacement && destination) window.DaLucaI18n.setHtml(destination, replacement.innerHTML);
    });
  }

  async function addCareVariantSilently(variantId, reportError) {
    const id = String(variantId || '').trim();
    if (!/^\d+$/.test(id)) return false;
    const rootUrl = (window.Shopify?.routes?.root || '/').replace(/\/?$/, '/');

    async function readCart() {
      const r = await fetch(rootUrl + 'cart.js', {
        method: 'GET',
        headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        credentials: 'same-origin',
        cache: 'no-store'
      });
      if (!r.ok) throw new Error('Unable to read cart');
      return r.json();
    }

    function containsVariant(cart) {
      return !!((cart?.items || []).find(line => String(line.variant_id || line.id) === id && isOwnedCare(line)));
    }

    async function updateChrome(cart) {
      document.querySelectorAll('.thb-item-count').forEach(node => {
        window.DaLucaI18n.setText(node, Number(cart?.item_count || 0) > 99 ? '*' : String(cart?.item_count || 0));
      });
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart, source: 'daluca-custom-care' } }));
      document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart, source: 'daluca-custom-care' } }));
    }

    try {
      let cart = await readCart();
      const previousQuantity = (cart.items || []).filter(line => String(line.variant_id || line.id) === id && isOwnedCare(line)).reduce((sum,line) => sum + Number(line.quantity || 0),0);

      const response = await fetch(rootUrl + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        credentials: 'same-origin',
        body: new URLSearchParams({ id: id, quantity: '1', 'properties[_DaLuca care item]': 'true' }).toString()
      });

      let payload = null;
      try { payload = await response.clone().json(); } catch (e) {}
      if (!response.ok || (payload && payload.status && Number(payload.status) >= 400)) {
        throw new Error(payload?.description || payload?.message || 'Unable to add care item');
      }

      try {
        cart = await readCart();
      } catch (_) {
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { source: 'daluca-custom-care' } }));
        return true;
      }
      const currentQuantity = (cart.items || []).filter(line => String(line.variant_id || line.id) === id && isOwnedCare(line)).reduce((sum,line) => sum + Number(line.quantity || 0),0);
      if (currentQuantity <= previousQuantity) throw new Error('Shopify did not return the added quantity in the cart.');
      updateChrome(cart);
      return true;
    } catch (error) {
      console.error('[DaLuca custom care verified add]', error, { variantId: id });
      if (typeof reportError === 'function') reportError(error?.message || 'Unable to add care item');
      return false;
    }
  }

  function creamAllowed(state) {
    if (state?.root?.dataset?.dalucaExotic === 'true') return false;
    const materialFields = (state.fields || []).filter(field => /Leather Color|Lizard Color|Alligator Color|Texture|Material/.test(field.name));
    const material = materialFields.map(field => selectedValue(field)).join(' ') + ' ' + (state.handle || '');
    return !/suede|roughout|lizard|alligator|crocodile|ostrich/i.test(material);
  }

  function syncCareEligibility(state) {
    const allowed = creamAllowed(state);
    state.builder?.querySelectorAll('[data-daluca-care-proxy="cream"]').forEach(card => {
      card.hidden = !allowed;
      card.style.setProperty('display', allowed ? '' : 'none', allowed ? '' : 'important');
      card.querySelectorAll('button').forEach(button => { button.disabled = !allowed; });
    });
    state.builder?.querySelectorAll('[data-daluca-care-proxy="shine"] .daluca-care-proxy-v35__content small').forEach(copy => {
      if (!copy.dataset.dalucaOriginalCopy) copy.dataset.dalucaOriginalCopy = window.DaLucaI18n.sourceText(copy);
      window.DaLucaI18n.setText(copy, allowed ? copy.dataset.dalucaOriginalCopy : 'Use dry; do not apply leather cream to this material.');
    });
    if (!allowed && state.careSelections?.cream && !state.creamRemovalPending) {
      const selection = state.careSelections.cream;
      state.creamRemovalPending = removeOneCareVariant(selection.variantId).then(removed => {
        if (removed) { delete state.careSelections.cream; refreshProxySummary(state); }
        return removed;
      }).finally(() => { state.creamRemovalPending = null; });
    }
  }

  function setCareProxyStatus(proxy, message) {
    let status = proxy.querySelector('[data-daluca-care-status]');
    if (!status && message) {
      status = document.createElement('p');
      status.dataset.dalucaCareStatus = 'true';
      status.setAttribute('role', 'alert');
      (proxy.querySelector('.daluca-care-proxy-v35__content') || proxy).appendChild(status);
    }
    if (status) {
      window.DaLucaI18n.setText(status, message || '');
      status.hidden = !message;
    }
  }

  function makeCareProxy(source, key, state) {
    if (!source) return null;
    const originalButton = source.querySelector('button[data-product-id],button.daluca-pdp-upsell__add');
    const image = source.querySelector('img');
    const titleLink = source.querySelector('.daluca-pdp-upsell__content > a, .daluca-pdp-upsell__content a');
    const reason = source.querySelector('.daluca-pdp-upsell__content > span');
    const priceEl = source.querySelector('.price,.amount,[class*="price"]');
    const titleText = clean(window.DaLucaI18n.chainText(() => (titleLink), [{kind:"text", optional:true}]) || source.querySelector('[data-daluca-upsell-name]')?.getAttribute('data-daluca-upsell-name') || key);
    const priceText = (clean(window.DaLucaI18n.chainText(() => (priceEl), [{kind:"text", optional:true}]) || '').match(/\$\s*[\d,.]+(?:\.\d{1,2})?/) || [])[0] || '';
    const priceAmount = priceText ? Number(priceText.replace(/[^0-9.]/g,'')) || 0 : 0;
    const directVariantId = key === 'cream'
      ? state?.root?.dataset?.dalucaVenetianVariantId
      : key === 'shine'
        ? state?.root?.dataset?.dalucaShineClothVariantId
        : key === 'tool'
          ? state?.root?.dataset?.dalucaSpringBarToolVariantId
          : '';
    const variantId = String(directVariantId || originalButton?.dataset?.productId || originalButton?.getAttribute('data-product-id') || '');
    const proxy = document.createElement('article');
    proxy.className = 'daluca-care-proxy-v35';
    proxy.dataset.dalucaCareProxy = key;
    proxy.dataset.dalucaCareVariantId = variantId;
    if (image) {
      const clone = image.cloneNode(true);
      clone.removeAttribute('id');
      const media = document.createElement('div');
      media.className = 'daluca-care-proxy-v35__media';
      media.appendChild(clone);
      proxy.appendChild(media);
    }
    const content = document.createElement('div');
    content.className = 'daluca-care-proxy-v35__content';
    const strong = document.createElement('strong');
    window.DaLucaI18n.setText(strong, titleText);
    content.appendChild(strong);
    if (reason) {
      const small = document.createElement('small');
      window.DaLucaI18n.setText(small, clean(window.DaLucaI18n.sourceText(reason)));
      content.appendChild(small);
    }
    if (priceText) {
      const price = document.createElement('span');
      window.DaLucaI18n.setText(price, priceText.replace(/\s+/g, ''));
      content.appendChild(price);
    }
    proxy.appendChild(content);
    if (variantId) {
      const add = document.createElement('button');
      add.type = 'button';
      add.className = 'daluca-care-proxy-v35__add';
      const restoreSelectedState = () => {
        const selected = !!state?.careSelections?.[key];
        proxy.classList.toggle('is-selected', selected);
        window.DaLucaI18n.setText(add, selected ? 'Remove −' : 'Add +');
        add.disabled = key === 'cream' && !creamAllowed(state);
        add.setAttribute('aria-pressed', selected ? 'true' : 'false');
      };
      restoreSelectedState();
      add.addEventListener('click', async event => {
        event.preventDefault();
        setCareProxyStatus(proxy, '');
        state.careSelections = state.careSelections || {};
        const selected = !!state.careSelections[key];
        if (key === 'cream' && !selected && !creamAllowed(state)) return;

        if (selected) {
          add.disabled = true;
          window.DaLucaI18n.setText(add, 'Removing…');
          const removed = await removeOneCareVariant(variantId);
          add.disabled = false;
          if (!removed) {
            restoreSelectedState();
            return;
          }
          delete state.careSelections[key];
          restoreSelectedState();
          refreshProxySummary(state);
          return;
        }

        add.disabled = true;
        window.DaLucaI18n.setText(add, 'Adding…');
        const added = await addCareVariantSilently(variantId, message => setCareProxyStatus(proxy, message));
        add.disabled = false;
        if (!added) {
          restoreSelectedState();
          return;
        }
        state.careSelections[key] = { key, title: titleText, price: priceAmount, variantId };
        syncCareEligibility(state);
        restoreSelectedState();
        refreshProxySummary(state);
      });
      proxy.appendChild(add);
    }
    return proxy;
  }

  function makeDirectCareAddon(key, config, state) {
    if (!config || !config.variantId) return null;
    const variantId = String(config.variantId || '').trim();
    if (!/^\d+$/.test(variantId)) return null;
    const priceAmount = (Number(config.priceCents) || 0) / 100;
    const proxy = document.createElement('article');
    proxy.className = 'daluca-care-proxy-v35 daluca-strap-addon-card-v360 daluca-care-direct-addon-v361' + (key === 'quick-release' ? ' daluca-care-direct-addon-v361--quick-release' : '');
    proxy.dataset.dalucaCareProxy = key;
    proxy.dataset.dalucaCareVariantId = variantId;
    proxy.dataset.dalucaStrapAddonCard = key;
    proxy.dataset.variantId = variantId;

    if (config.image) {
      const media = document.createElement('div');
      media.className = 'daluca-care-proxy-v35__media daluca-strap-addon-card-v360__media';
      const img = document.createElement('img');
      img.src = config.image;
      img.alt = '';
      img.loading = 'lazy';
      media.appendChild(img);
      proxy.appendChild(media);
    }

    const content = document.createElement('div');
    content.className = 'daluca-care-proxy-v35__content';
    const strong = document.createElement('strong');
    window.DaLucaI18n.setText(strong, config.title || key);
    content.appendChild(strong);
    if (config.reason) {
      const small = document.createElement('small');
      window.DaLucaI18n.setText(small, config.reason);
      content.appendChild(small);
    }
    if (priceAmount > 0) {
      const price = document.createElement('span');
      window.DaLucaI18n.setText(price, money(priceAmount));
      content.appendChild(price);
    }
    proxy.appendChild(content);

    if (config.optionsUrl) {
      const options = document.createElement('button');
      options.type = 'button';
      options.className = 'daluca-care-proxy-v35__add daluca-addon-options';
      options.dataset.dalucaCuffOptions = config.optionsUrl;
      window.DaLucaI18n.setText(options, 'Add +');
      options.setAttribute('aria-haspopup', 'dialog');
      options.setAttribute('aria-label', 'Add ' + (config.title || key) + ' to cart — choose options');
      proxy.appendChild(options);
      return proxy;
    }

    const add = document.createElement('button');
    add.type = 'button';
    add.className = 'daluca-care-proxy-v35__add daluca-strap-addon-card-v360__button';
    const restoreSelectedState = () => {
      const selected = !!state?.careSelections?.[key];
      proxy.classList.toggle('is-selected', selected);
      window.DaLucaI18n.setText(add, selected ? 'Remove −' : 'Add +');
      add.disabled = false;
      add.setAttribute('aria-pressed', selected ? 'true' : 'false');
      add.dataset.inCart = selected ? '1' : '0';
    };
    restoreSelectedState();

    add.addEventListener('click', async event => {
      event.preventDefault();
      event.stopPropagation();
      setCareProxyStatus(proxy, '');
      state.careSelections = state.careSelections || {};
      const selected = !!state.careSelections[key];
      add.disabled = true;
      window.DaLucaI18n.setText(add, selected ? 'Removing…' : 'Adding…');

      if (selected) {
        const removed = await removeOneCareVariant(variantId);
        if (!removed) {
          restoreSelectedState();
          return;
        }
        delete state.careSelections[key];
      } else {
        const added = await addCareVariantSilently(variantId, message => setCareProxyStatus(proxy, message));
        if (!added) {
          restoreSelectedState();
          return;
        }
        state.careSelections[key] = {
          key,
          title: config.title || key,
          price: priceAmount,
          variantId
        };
      }

      restoreSelectedState();
      refreshProxySummary(state);
    });
    proxy.appendChild(add);
    return proxy;
  }

  function integrateCareIntoExtras(section, state) {
    if (!section || section.dataset.dalucaCareEmbedded === '1') return;
    const body = section.querySelector('.daluca-builder-section__body');
    if (!body) return;
    const care = findCareSource(state);

    const inline = document.createElement('div');
    inline.className = 'daluca-care-inline-v35';
    window.DaLucaI18n.setHtml(inline, '<div class="daluca-care-inline-v35__head"><div><span data-daluca-sequential-care-ref aria-hidden="true"></span><strong>Care & Installation</strong></div><small>Optional extras</small></div><div class="daluca-care-inline-v35__items"></div>');
    const items = inline.querySelector('.daluca-care-inline-v35__items');

    const creamField = body.querySelector('[data-daluca-proxy-field="Venetian Cream"]');
    if (creamField) {
      creamField.hidden = true;
      creamField.setAttribute('aria-hidden', 'true');
      creamField.classList.add('daluca-legacy-venetian-field-v352');
    }

    const rootData = state?.root?.dataset || {};
    const isExotic = rootData.dalucaExotic === 'true';
    // Exotic skins do not use Venetian Cream. Keep the legacy Globo field
    // retired, and do not recreate the visible Cream card for these products.
    const cream = isExotic ? null : makeCareProxy(careCard(care, /venetian\s+cream/i), 'cream', state);
    const shine = makeCareProxy(careCard(care, /shine\s+cloth/i), 'shine', state);
    const tool = makeCareProxy(careCard(care, /spring\s+bar\s+tool/i), 'tool', state);
    const standardBars = makeDirectCareAddon('spring-bars', {
      variantId: rootData.dalucaSpringBarsVariantId,
      title: rootData.dalucaSpringBarsTitle || 'Extra Spring Bars',
      reason: 'One extra standard pair for future strap changes.',
      priceCents: rootData.dalucaSpringBarsPriceCents,
      image: rootData.dalucaSpringBarsImage
    }, state);
    const exactCustomLeather = String(state?.handle || '').toLowerCase() === 'custom-leather-watch-strap';
    const nativeQuickRelease = (state.fields || []).some(field => field.name === 'Quick Release');
    const quickReleaseEligible = !nativeQuickRelease && (rootData.dalucaQuickReleaseEligible === 'true' || exactCustomLeather);
    const quickRelease = quickReleaseEligible ? makeDirectCareAddon('quick-release', {
      variantId: rootData.dalucaQuickReleaseVariantId,
      title: 'Quick-Release Spring Bars',
      reason: 'Tool-free strap changes with compatible spring bars.',
      priceCents: rootData.dalucaQuickReleasePriceCents,
      image: rootData.dalucaQuickReleaseImage
    }, state) : null;
    const tray = isExotic ? makeDirectCareAddon('the-tray', {
      variantId: rootData.dalucaTrayVariantId,
      title: rootData.dalucaTrayTitle || 'The Tray',
      reason: 'A refined place to rest your watch between wears.',
      priceCents: rootData.dalucaTrayPriceCents,
      image: rootData.dalucaTrayImage
    }, state) : null;
    const cuff = (isExotic || exactCustomLeather) ? makeDirectCareAddon('the-cuff', {
      variantId: rootData.dalucaCuffVariantId,
      title: rootData.dalucaCuffTitle || 'The Cuff',
      reason: 'Select your wrist size and Da Luca branding preference.',
      optionsUrl: (window.Shopify?.routes?.root || '/') + 'products/the-cuff',
      priceCents: rootData.dalucaCuffPriceCents,
      image: rootData.dalucaCuffImage
    }, state) : null;
    if (cream) items.appendChild(cream);
    if (shine) items.appendChild(shine);
    if (tool) items.appendChild(tool);
    if (standardBars) items.appendChild(standardBars);
    if (quickRelease) items.appendChild(quickRelease);
    if (tray) items.appendChild(tray);
    if (cuff) items.appendChild(cuff);

    if (items.children.length) body.appendChild(inline);
    section.dataset.dalucaCareEmbedded = '1';
    if (care) care.classList.add('daluca-consolidated-top-suppressed');
  }

  function suppressTopConfiguratorChrome(state) {
    const selectors = [
      '.daluca-concierge-step--complete',
      '.daluca-pdp-upsells--essentials'
    ];
    selectors.forEach(selector => state.root.querySelectorAll(selector).forEach(el => el.classList.add('daluca-consolidated-top-suppressed')));
  }

  function ensureOptionPreview() {
    let hover = document.querySelector('.daluca-option-preview-v35');
    let lightbox = document.querySelector('.daluca-option-lightbox-v35');
    if (!hover) {
      hover = document.createElement('div');
      hover.className = 'daluca-option-preview-v35';
      window.DaLucaI18n.setHtml(hover, '<div class="daluca-option-preview-v35__title"></div><div class="daluca-option-preview-v35__image"><img alt=""></div>');
      document.body.appendChild(hover);
    }
    if (!lightbox) {
      lightbox = document.createElement('div');
      lightbox.className = 'daluca-option-lightbox-v35';
      window.DaLucaI18n.setHtml(lightbox, '<div class="daluca-option-lightbox-v35__panel"><button type="button" aria-label="Close image preview">×</button><div class="daluca-option-lightbox-v35__title"></div><img alt=""></div>');
      lightbox.addEventListener('click', event => {
        if (event.target === lightbox || event.target.closest('button')) lightbox.classList.remove('is-visible');
      });
      document.body.appendChild(lightbox);
    }
    return { hover, lightbox };
  }

  function proxyPreviewImage(button) {
    return button?.querySelector('img') || null;
  }

  function previewSource(img) {
    if (!img) return '';
    const srcset = clean(img.getAttribute('srcset') || '');
    if (srcset) {
      const candidates = srcset.split(',').map(part => part.trim()).map(part => {
        const bits = part.split(/\s+/);
        return { src: bits[0], width: parseInt(bits[1], 10) || 0 };
      }).filter(item => item.src);
      candidates.sort((a,b) => b.width - a.width);
      if (candidates[0]) return candidates[0].src;
    }
    return img.currentSrc || img.src || '';
  }

  function showHoverPreview(button) {
    const img = proxyPreviewImage(button);
    if (!img) return;
    const ui = ensureOptionPreview();
    const preview = ui.hover.querySelector('img');
    const title = ui.hover.querySelector('.daluca-option-preview-v35__title');
    preview.src = previewSource(img);
    preview.alt = button.title || button.getAttribute('aria-label') || '';
    window.DaLucaI18n.setText(title, button.title || button.getAttribute('aria-label') || 'Option preview');
    ui.hover.dataset.previewField = button.closest('[data-daluca-proxy-field]')?.getAttribute('data-daluca-proxy-field') || '';
    ui.hover.classList.add('is-visible');
  }

  function hideHoverPreview() {
    document.querySelector('.daluca-option-preview-v35')?.classList.remove('is-visible');
  }

  function showLightboxPreview(button) {
    const img = proxyPreviewImage(button);
    if (!img) return;
    const ui = ensureOptionPreview();
    const preview = ui.lightbox.querySelector('img');
    const title = ui.lightbox.querySelector('.daluca-option-lightbox-v35__title');
    preview.src = previewSource(img);
    preview.alt = button.title || button.getAttribute('aria-label') || '';
    window.DaLucaI18n.setText(title, button.title || button.getAttribute('aria-label') || 'Option preview');
    ui.lightbox.dataset.previewField = button.closest('[data-daluca-proxy-field]')?.getAttribute('data-daluca-proxy-field') || '';
    ui.lightbox.classList.add('is-visible');
  }

  function bindOptionPreviews() {
    if (document.documentElement.dataset.dalucaProxyPreviewV35 === '1') return;
    document.documentElement.dataset.dalucaProxyPreviewV35 = '1';
    ensureOptionPreview();
    const finePointer = window.matchMedia?.('(hover: hover) and (pointer: fine)').matches;
    if (finePointer) {
      document.addEventListener('pointerover', event => {
        const button = event.target.closest?.('.daluca-custom-builder-live--consolidated .daluca-proxy-choice[data-daluca-has-visual="true"]');
        if (button) showHoverPreview(button);
      });
      document.addEventListener('pointerout', event => {
        const button = event.target.closest?.('.daluca-custom-builder-live--consolidated .daluca-proxy-choice[data-daluca-has-visual="true"]');
        if (!button) return;
        if (event.relatedTarget && button.contains(event.relatedTarget)) return;
        hideHoverPreview();
      });
    }
    if (!finePointer) {
      document.addEventListener('click', event => {
        const button = event.target.closest?.('.daluca-custom-builder-live--consolidated .daluca-proxy-choice[data-daluca-has-visual="true"]');
        if (!button) return;
        showLightboxPreview(button);
      }, true);
    }
    document.addEventListener('keydown', event => {
      if (event.key === 'Escape') {
        hideHoverPreview();
        document.querySelector('.daluca-option-lightbox-v35')?.classList.remove('is-visible');
      }
    });
  }

  function restoreEmbeddedFitChecker(builder, state) {
    if (!builder || !state?.root) return;
    const fit = builder.querySelector('[data-daluca-pdp-fit]');
    if (!fit) return;
    const body = state.root.querySelector('.daluca-concierge-step--fit .daluca-concierge-step__body');
    if (!body) return;
    const skip = body.querySelector('.daluca-concierge-step__skip');
    body.insertBefore(fit, skip || null);
  }

  function alphaRef(index) {
    let n = Math.max(0, Number(index) || 0);
    let out = '';
    do {
      out = String.fromCharCode(65 + (n % 26)) + out;
      n = Math.floor(n / 26) - 1;
    } while (n >= 0);
    return out;
  }

  function applySequentialRefs(columns, state) {
    const map = {};
    let index = 0;
    const assignField = (fieldEl) => {
      const name = fieldEl?.getAttribute('data-daluca-proxy-field');
      if (!name) return;
      const code = alphaRef(index++);
      map[name] = code;
      const badge = fieldEl.querySelector(':scope > .daluca-proxy-field__heading .daluca-proxy-field__ref');
      if (badge) window.DaLucaI18n.setText(badge, code);
    };

    columns.querySelectorAll('.daluca-builder-section').forEach(section => {
      const body = section.querySelector(':scope > .daluca-builder-section__body');
      if (!body) return;
      Array.from(body.children).forEach(item => {
        if (item.classList.contains('daluca-proxy-field')) {
          assignField(item);
          return;
        }
        if (item.classList.contains('daluca-care-inline-v35')) {
          const code = alphaRef(index++);
          map['Care & Installation'] = code;
          map['Venetian Cream'] = code;
          const badge = item.querySelector('[data-daluca-sequential-care-ref]');
          if (badge) window.DaLucaI18n.setText(badge, code);
          const creamBadge = item.querySelector('[data-daluca-proxy-field="Venetian Cream"] .daluca-proxy-field__ref');
          if (creamBadge) window.DaLucaI18n.setText(creamBadge, code);
        }
      });
    });
    state.refMap = map;
  }

  function summaryRef(fieldName, state) {
    return state?.refMap?.[fieldName] || '';
  }

  function summaryDefault(label) {
    return /details|notes/i.test(label) ? 'None added' : 'Not selected';
  }

  function selectedCareEntries(state) {
    return Object.values(state?.careSelections || {}).filter(Boolean);
  }

  function careSummaryValue(state, nativeCreamValue) {
    const values = [];
    const nativeValue = clean(nativeCreamValue || '');
    if (nativeValue && !/^(?:no|none|without|skip|not selected|please select)$/i.test(nativeValue)) values.push(nativeValue);
    selectedCareEntries(state).forEach(entry => {
      const label = clean(entry?.title || '');
      if (!label) return;
      const price = Number(entry?.price) || 0;
      const pricedLabel = price > 0 ? label + ' (+' + money(price) + ')' : label;
      if (!values.includes(pricedLabel)) values.push(pricedLabel);
    });
    return values.length ? values.join(', ') : 'None selected';
  }

  function refOrderValue(ref) {
    const value = clean(ref).toUpperCase();
    if (!value) return 10000;
    let out = 0;
    for (let i = 0; i < value.length; i += 1) out = out * 26 + (value.charCodeAt(i) - 64);
    return out;
  }

  function summaryRows(state, selection = currentCartSelection(state)) {
    const fields = orderedFields(
      selection.activeFields.filter(field => field.isExpected && field.name !== 'Care & Installation'),
      state.profile
    ).filter(nativeVisible);
    const rows = [];
    const seen = new Set();

    fields.forEach(field => {
      if (field.name === 'Venetian Cream') return; // represented by M · Care & Installation
      const isBuckle = /^Buckle(?:\s|$|\()/i.test(field.name);
      const label = isBuckle ? 'Buckle' : field.displayLabel;
      const key = isBuckle ? 'Buckle' : label;
      if (seen.has(key)) return;
      seen.add(key);
      const value = selectedValue(field);
      rows.push({
        ref: summaryRef(field.name, state),
        label,
        value: displayFieldValue(field, value) || summaryDefault(label),
        selected: !!value
      });
    });

    const cream = selection.activeFields.find(field => field.name === 'Venetian Cream' && nativeVisible(field));
    const creamValue = clean(cream ? selectedValue(cream) : '');
    const careValue = careSummaryValue(state, creamValue);
    const careRow = { ref: summaryRef('Care & Installation', state), label: 'Care & Installation', value: careValue, selected: careValue !== 'None selected' };
    const detailsIndex = rows.findIndex(row => /details|notes/i.test(row.label || ''));
    if (detailsIndex >= 0) rows.splice(detailsIndex, 0, careRow);
    else rows.push(careRow);
    rows.sort((a,b) => refOrderValue(a.ref) - refOrderValue(b.ref));
    return rows;
  }

  function makeSection(key, fields, state) {
    const def = SECTION_DEFS[key];
    const section = document.createElement('section');
    section.className = 'daluca-consolidated-section daluca-builder-section daluca-builder-section--' + key;
    if (key === 'leather' || key === 'stitching' || key === 'hardware') section.classList.add('daluca-builder-section--visual');
    if (key === 'details') section.classList.add('daluca-builder-section--details');
    section.dataset.dalucaProxySection = key;

    const head = document.createElement('div');
    head.className = 'daluca-consolidated-section__head daluca-builder-section__head';
    const number = document.createElement('span');
    number.className = 'daluca-builder-section__number';
    window.DaLucaI18n.setText(number, def.number);
    const title = document.createElement('h3');
    window.DaLucaI18n.setText(title, state.handle === 'the-74-vintage-leather-watch-strap' && key === 'leather' ? 'Color & “74” Marking' : def.title);
    head.append(number, title);
    section.appendChild(head);

    const body = document.createElement('div');
    body.className = 'daluca-consolidated-section__body daluca-builder-section__body';
    fields.forEach(field => {
      const item = makeField(field, state);
      item.classList.add('daluca-builder-field');
      item.dataset.dalucaFieldName = field.name;
      body.appendChild(item);
    });
    section.appendChild(body);
    if (key === 'fit') embedFitChecker(section, state);
    if (key === 'extras') integrateCareIntoExtras(section, state);
    return section;
  }

  function selectedSummaryRows(state, selection) {
    return summaryRows(state, selection);
  }

  function moneyNumber(value) {
    const match = clean(value).match(/\$\s*([\d,]+(?:\.\d{1,2})?)/);
    return match ? Number(match[1].replace(/,/g,'')) : null;
  }

  function basePriceNumber(state) {
    if (typeof state.basePrice === 'number' && !Number.isNaN(state.basePrice)) return state.basePrice;
    const selectors = [
      '.daluca-concierge-total [data-daluca-total-base]',
      '[data-daluca-total-base]',
      '.product-price-container .price .amount',
      '.product-price-container .price',
      '.product-price-container',
      '[data-product-price]'
    ];
    for (const selector of selectors) {
      const el = state.root.querySelector(selector);
      const amount = moneyNumber(window.DaLucaI18n.chainText(() => (el), [{kind:"text", optional:true}]) || '');
      if (amount != null) {
        state.basePrice = amount;
        return amount;
      }
    }
    return null;
  }

  function selectedOptionPriceEntries(state, selection = currentCartSelection(state)) {
    const entries = [];
    selection.activeFields.filter(field => field.name !== 'Venetian Cream' && field.name !== 'Care & Installation' &&
      !/details|notes|instructions/i.test(field.name) && nativeVisible(field)).forEach(field => {
      const value = selectedValue(field);
      const matches = String(value || '').matchAll(/\+\s*\$\s*([\d,]+(?:\.\d{1,2})?)/g);
      let price = 0;
      for (const match of matches) price += Number(match[1].replace(/,/g,'')) || 0;
      if (price > 0) entries.push({title: field.displayLabel || field.name, price});
    });
    return entries;
  }

  function selectedOptionExtrasNumber(state, selection) {
    return selectedOptionPriceEntries(state, selection).reduce((sum, entry) => sum + entry.price, 0);
  }

  function selectedExtrasNumber(state, selection) {
    return selectedOptionExtrasNumber(state, selection) + selectedCareEntries(state).reduce((total, entry) => total + (Number(entry?.price) || 0), 0);
  }

  function money(value) {
    return typeof value === 'number' && !Number.isNaN(value) ? '$' + value.toFixed(2) : '—';
  }


  function nativeCartForm(state) {
    if (!state?.root) return null;

    // V3.35: always choose the main Shopify product form. Care/upsell products
    // can also expose cart forms inside the PDP, and selecting the first generic
    // /cart/add form can accidentally serialize the Venetian Cream product.
    const primary = state.root.querySelector('product-form:not([data-sticky]) form[data-type="add-to-cart-form"]');
    if (primary) return primary;

    const productId = String(state.root.dataset.dalucaMainProductId || '');
    const forms = Array.from(state.root.querySelectorAll('form[action*="/cart/add"], form[data-type="add-to-cart-form"]'));
    const exact = forms.find(form => {
      const formProductId = form.querySelector('input[name="product-id"]')?.value || '';
      return productId && String(formProductId) === productId;
    });
    if (exact) return exact;

    return forms.find(form =>
      !form.closest('.daluca-pdp-upsell,.daluca-care-proxy-v35,[data-daluca-care-proxy]') &&
      form.querySelector('button[name="add"],button[type="submit"],input[type="submit"]')
    ) || null;
  }

  function nativeAddButton(state) {
    const form = nativeCartForm(state);
    return form?.querySelector('button[name="add"],button[type="submit"],input[type="submit"]') || null;
  }

  function cartIssueLabel(field) {
    if (!field) return '';
    if (/^Buckle(?:\s|$|\()/i.test(field.name || '')) return 'Buckle';
    return clean(field.displayLabel || field.name || '');
  }

  function proxyCartIssues(state, includeUnselectedWhenBlocked) {
    const allFresh = neutralizeLegacyVenetianCream(state, collectFields(state.app, state.profile));
    applyBuckleAvailability(state, allFresh);
    const fresh = allFresh.filter(field => field.isExpected && nativeVisible(field))
      .map(field => ({ ...field, controls: cartFieldControls(field) }));
    // Keep the full field set in state. The summary still filters to expected
    // fields, while cart validation can also see any native required Globo
    // control that is currently visible but was not part of the product profile.
    state.fields = allFresh;
    const issues = [];
    const seen = new Set();
    const add = field => {
      const label = cartIssueLabel(field);
      if (!label || seen.has(label)) return;
      seen.add(label);
      issues.push({ name: field.name, label });
    };

    // The explicit product profile is authoritative for all consolidated custom
    // straps. Unrecognized Globo controls (including obsolete legacy fields)
    // can never block cart.
    const validationFields = fresh;

    validationFields.forEach(field => {
      if (field.name === 'Care & Installation' || field.name === 'Venetian Cream' || /details|notes/i.test(field.name)) return;
      if (field.required && !selectedValue(field)) add(field);
    });

    // Globo sometimes disables its native Add to Cart button without exposing
    // required/aria-required on the underlying controls. When that happens,
    // surface the still-unselected build choices instead of silently doing
    // nothing. This gives the customer an actionable checklist.
    if (includeUnselectedWhenBlocked && !issues.length) {
      fresh.forEach(field => {
        if (field.name === 'Care & Installation' || field.name === 'Venetian Cream' || /details|notes/i.test(field.name)) return;
        if (!selectedValue(field) && ['fit','leather','stitching','hardware','extras'].includes(sectionFor(field))) add(field);
      });
    }

    return issues;
  }

  function resyncNativeSelections(state, selection = currentCartSelection(state)) {
    if (!state?.app) return;
    const fields = selection.activeFields.filter(field => field.name !== 'Venetian Cream' && field.name !== 'Care & Installation');
    fields.forEach(field => {
      const replay = control => {
        // An earlier native event can replace another conditional control.
        // Never replay a stale, hidden or disabled choice after that replacement.
        ['input', 'change'].forEach(type => {
          if (cartFieldControls(field).includes(control)) control.dispatchEvent(new Event(type, { bubbles: true }));
        });
      };
      const select = field.controls.find(control => control.tagName === 'SELECT');
      if (select && clean(select.value)) replay(select);
      field.controls.filter(control => /^(radio|checkbox)$/i.test(control.type) && control.checked).forEach(control => {
        replay(control);
      });
      field.controls.filter(control => control.tagName === 'TEXTAREA' || ['text','number','search','email'].includes(control.type)).forEach(control => {
        if (!clean(control.value)) return;
        replay(control);
      });
    });
  }

  function nativeCartPropertyValues(selection, data) {
    const properties = {};
    selection.activeFields.filter(field => field.isExpected && field.name !== 'Venetian Cream' && field.name !== 'Care & Installation').forEach(field => {
      field.controls.forEach(control => {
        const name = (control.getAttribute('data-name') || control.name || '').match(/^properties\[(.+)\]$/)?.[1];
        if (!name || name[0] === '_') return;
        const propertyValues = data.getAll('properties[' + name + ']');
        const values = propertyValues.length ? propertyValues : data.getAll(control.name);
        if (values.length === 1 && typeof values[0] === 'string') properties[name] = values[0];
      });
    });
    return properties;
  }

  function nativeCartFieldAliases(field) {
    return Array.from(new Set([...cartFieldPropertyKeys(field), ...field.controls.map(control =>
      (control.getAttribute('data-name') || control.name || '').match(/^properties\[(.+)\]$/)?.[1] || '')])).filter(Boolean);
  }

  function hasEquivalentNativeCartProperty(selection, properties, propertyName, value) {
    const label = propertyName.match(/^properties\[(.+)\]$/)?.[1];
    if (!label) return false;
    const field = selection.activeFields.find(field => clean(field.displayLabel || field.name) === label);
    if (!field) return false;
    const aliases = nativeCartFieldAliases(field).filter(alias => alias !== label && Object.prototype.hasOwnProperty.call(properties, alias));
    return aliases.length > 0 && aliases.every(alias => cartChoiceValue(field, properties[alias]) === cartChoiceValue(field, value));
  }

  function submitThroughNativeButton(state, button) {
    if (window.DaLucaQuickReleaseConsent && !window.DaLucaQuickReleaseConsent.validate()) return false;
    const form = nativeCartForm(state);
    if (!form || !button || button.disabled || button.getAttribute('aria-disabled') === 'true') return false;
    // Paid choices must pass through Globo's own validator and add-on handler.
    // Never enable a blocked native button or fall back to a base-price POST.
    form.querySelectorAll('[data-daluca-canonical-property]').forEach(input => input.remove());
    const properties = new FormData();
    const selection = currentCartSelection(state);
    const nativeProperties = nativeCartPropertyValues(selection, new FormData(form));
    appendConfiguredProperties(state, properties, false, selection);
    properties.forEach((value, name) => {
      if (Array.from(form.elements).some(input => input.name === name) ||
          hasEquivalentNativeCartProperty(selection, nativeProperties, name, value)) return;
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      input.value = value;
      input.setAttribute('data-daluca-canonical-property', 'true');
      form.appendChild(input);
    });
    button.click();
    window.setTimeout(() => {
      const errors = Array.from(state.app.querySelectorAll('.gpo-element.has-error'));
      if (!errors.length) return;
      const issues = errors.map(container => {
        const field = state.fields.find(item => item.containers.some(node => node === container || node.contains(container) || container.contains(node)));
        return field && field.isExpected ? { name: field.name, label: cartIssueLabel(field) } : null;
      }).filter(Boolean);
      showProxyCartValidation(state, issues, 'The product options could not be validated. Please review your selections or contact DaLuca for help with this build.', false);
    }, 350);
    return true;
  }

  function cartSectionsToRender() {
    return [
      { id: 'Cart', section: 'main-cart', selector: '.thb-cart-form' },
      { id: 'Cart-Drawer', section: 'cart-drawer', selector: '.cart-drawer' },
      { id: 'cart-drawer-toggle', section: 'cart-bubble', selector: '.thb-item-count' }
    ];
  }

  function renderCartSections(response) {
    if (!response?.sections) return;
    cartSectionsToRender().forEach(section => {
      const host = document.getElementById(section.id);
      const html = response.sections?.[section.section];
      if (!host || !html) return;
      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const replacement = parsed.querySelector(section.selector);
      const destination = host.querySelector(section.selector) || host;
      if (replacement && destination) window.DaLucaI18n.setHtml(destination, replacement.innerHTML);
      const cartEl = document.getElementById('Cart');
      if (cartEl?.renderContents) cartEl.renderContents(response);
    });
    const drawer = document.getElementById('Cart-Drawer');
    if (drawer?.open) drawer.open();
  }

  function appendConfiguredProperties(state, formData, replaceAliases, selection = currentCartSelection(state)) {
    if (!state || !formData) return;
    selection.activeFields.forEach((field, index) => {
      if (!field || !field.isExpected || field.name === 'Venetian Cream' || field.name === 'Care & Installation') return;
      if (!nativeVisible(field) && !/details|notes/i.test(field.name || '')) return;
      const value = clean(selectedCartValue(field));
      if (!value) return;
      const label = clean(field.displayLabel || field.name);
      if (!label) return;
      const key = 'properties[' + label + ']';
      if (!formData.has(key)) formData.append(key, value);
      if (!replaceAliases) return;
      const canonicalValues = formData.getAll(key);
      if (canonicalValues.length !== 1 || typeof canonicalValues[0] !== 'string' || canonicalValues[0].trim() !== value.trim()) return;
      const originalControls = selection.fields[index].controls;
      const nativeNames = new Set([field.name, ...Array.from(field.rawNames || []), ...originalControls.map(control => control.getAttribute('name') || '')]);
      nativeNames.forEach(rawName => {
        const raw = String(rawName || '').trim();
        const match = raw.match(/^properties\[(.*)\]$/);
        const nativeLabel = match ? match[1] : raw;
        if (!nativeLabel || nativeLabel[0] === '_' || nativeLabel === label) return;
        const nativeKey = 'properties[' + nativeLabel + ']';
        const nativeValues = formData.getAll(nativeKey);
        if (nativeValues.length && nativeValues.every(entry => typeof entry === 'string' && entry.trim() === value.trim())) {
          formData.delete(nativeKey);
        }
      });
    });
  }

  function prepareNativeSubmission(state) {
    if (!state?.app) return;
    nativeCartForm(state)?.querySelectorAll('[data-daluca-canonical-property]').forEach(input => input.remove());
    hardRetireLegacyVenetianDom(state);

    // Any native control that is not currently visible is conditional/orphaned
    // UI and must not be allowed to invalidate the visible builder. This also
    // catches legacy Globo fields with generic names such as "Select 2" that
    // cannot be reliably identified by their label text.
    Array.from(state.app.querySelectorAll('input,select,textarea')).forEach(control => {
      if (control.type === 'hidden') return;
      if (control.hasAttribute('data-daluca-retired-care-control')) {
        control.disabled = !legacyCareNoSelected(control);
        control.required = false;
        return;
      }
      const container = control.closest('.gpo-element,[data-gpo-element],[class*="gpo-"]') || control.parentElement;
      let visible = true;
      let node = container;
      while (node && node !== state.app?.parentElement) {
        if (node.hidden || node.getAttribute?.('aria-hidden') === 'true') { visible = false; break; }
        const style = getComputedStyle(node);
        if (style.display === 'none' || style.visibility === 'hidden') { visible = false; break; }
        if (node === state.app) break;
        node = node.parentElement;
      }

      if (!visible || control.hasAttribute('data-daluca-retired-care-control')) {
        if (!control.hasAttribute('data-daluca-submit-was-required')) {
          control.setAttribute('data-daluca-submit-was-required', control.required || control.getAttribute('aria-required') === 'true' ? '1' : '0');
        }
        control.required = false;
        control.removeAttribute('required');
        control.setAttribute('aria-required', 'false');
        control.disabled = true;
        control.setAttribute('data-daluca-submit-hidden-disabled', 'true');
      } else if (control.getAttribute('data-daluca-submit-hidden-disabled') === 'true' && !control.hasAttribute('data-daluca-retired-care-control')) {
        control.disabled = false;
        if (control.getAttribute('data-daluca-submit-was-required') === '1') {
          control.required = true;
          control.setAttribute('aria-required', 'true');
        }
        control.removeAttribute('data-daluca-submit-hidden-disabled');
      }
    });
  }

  function resolvedVariantId(state, form) {
    // V3.35: the product root is authoritative. This prevents any embedded
    // care-product form or Globo add-on control from replacing the strap id.
    const rootId = state?.root?.dataset?.dalucaMainVariantId;
    if (rootId) return String(rootId);
    const selected = state?.root?.querySelector('[id^="SelectedVariant-"][data-variant-id], [data-variant-id][data-available]');
    const selectedId = selected?.getAttribute('data-variant-id');
    if (selectedId) return String(selectedId);
    const formId = form?.querySelector('input[name="id"]')?.value;
    if (formId) return String(formId);
    return '';
  }

  function sanitizeVenetianFromGloboPayload(state, formData) {
    if (!formData) return;
    const venetianVariantId = String(state?.root?.dataset?.dalucaVenetianVariantId || '');
    const optionsKey = 'properties[_gpo_options]';
    const addonsKey = 'properties[_gpo_addon_products]';
    const productGroupKey = 'properties[_gpo_product_group]';

    Array.from(formData.entries()).forEach(([key, value]) => {
      const keyText = String(key || '');
      const valueText = String(value || '');
      // Never delete Globo's serialized system payloads wholesale. They contain
      // all legitimate paid custom-strap options and surcharges. Clean their
      // Venetian entry surgically below instead.
      if (keyText === optionsKey || keyText === addonsKey || keyText === productGroupKey) return;
      if (/venetian\s*cream/i.test(keyText) || /venetian\s*cream/i.test(valueText)) {
        formData.delete(key);
      }
    });

    const optionsRaw = formData.get(optionsKey);
    if (optionsRaw) {
      try {
        const options = JSON.parse(String(optionsRaw));
        Object.keys(options || {}).forEach(key => {
          const value = options[key];
          if (/venetian\s*cream/i.test(String(key)) || /venetian\s*cream/i.test(String(value))) delete options[key];
        });
        formData.set(optionsKey, JSON.stringify(options));
      } catch (_) {
        // Preserve the serialized Globo option payload if it is unexpectedly
        // non-JSON; deleting it would also delete legitimate paid strap options.
      }
    }

    const addonsRaw = formData.get(addonsKey);
    if (addonsRaw && venetianVariantId) {
      try {
        const addons = JSON.parse(String(addonsRaw));
        if (Array.isArray(addons)) {
          const filtered = addons.filter(item => {
            const id = String(item?.i ?? item?.id ?? item?.variant_id ?? '');
            return id !== venetianVariantId;
          });
          formData.set(addonsKey, JSON.stringify(filtered));
        }
      } catch (_) {}
    }

    if (venetianVariantId) {
      Array.from(formData.entries()).forEach(([key, value]) => {
        const keyText = String(key || '');
        const valueText = String(value || '');
        if (keyText === 'id') return;
        if (/^(?:items(?:\[[^\]]*\])?\[id\]|items\[\d+\]\[id\])$/i.test(keyText) && valueText === venetianVariantId) {
          formData.delete(key);
        }
      });
    }
  }

  async function ajaxSubmitConfiguredProduct(state, form, proxyButton) {
    if (window.DaLucaQuickReleaseConsent && !window.DaLucaQuickReleaseConsent.validate()) return false;
    if (!form) return false;
    syncCareEligibility(state);
    if (state.creamRemovalPending) await state.creamRemovalPending;
    if (!creamAllowed(state) && state.careSelections?.cream) {
      window.alert('Leather cream is not suitable for this material. Please remove the cream from your cart before continuing.');
      return false;
    }
    // Re-neutralize immediately before serialization. This guarantees the old
    // invisible Venetian Cream Globo control can neither invalidate the form
    // nor be serialized as a paid option. The three visible care cards remain
    // separate products and are unaffected.
    forceLegacyVenetianOff(state);
    neutralizeLegacyVenetianCream(state, collectFields(state.app, state.profile));
    prepareNativeSubmission(state);

    const formData = new FormData(form);
    sanitizeVenetianFromGloboPayload(state, formData);
    const variantId = resolvedVariantId(state, form);
    if (variantId) formData.set('id', variantId);
    if (!formData.has('quantity')) formData.set('quantity', '1');
    appendConfiguredProperties(state, formData, true);
    formData.set('sections', cartSectionsToRender().map(item => item.section).join(','));
    formData.set('sections_url', window.location.pathname);

    try {
      window.__dalucaLastCustomCartPayload = Array.from(formData.entries()).map(([key, value]) => [key, String(value)]);
    } catch (_) {}

    if (proxyButton) {
      proxyButton.disabled = true;
      proxyButton.classList.add('loading');
      proxyButton.setAttribute('aria-disabled', 'true');
    }

    try {
      const shopRoot = (window.Shopify?.routes?.root || '/').replace(/\/?$/, '/');
      const controller = typeof AbortController !== 'undefined' ? new AbortController() : null;
      const timeout = controller ? window.setTimeout(() => controller.abort(), 15000) : null;
      let response;
      try {
        response = await fetch(shopRoot + 'cart/add.js', {
          method: 'POST',
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
            'Accept': 'application/json'
          },
          body: formData,
          signal: controller?.signal
        });
      } finally {
        if (timeout) window.clearTimeout(timeout);
      }
      const data = await response.json();
      if (!response.ok || data?.status) {
        window.DaLucaCartEditor?.submissionRejected?.(form);
        const message = data?.description || data?.message || 'Shopify could not add this configured strap. Please review the selections and try again.';
        showProxyCartValidation(state, [], message, false);
        return false;
      }
      clearProxyCartValidation(state);
      if (!window.DaLucaCartEditor?.isSaving?.(form)) {
        renderCartSections(data);
        document.dispatchEvent(new CustomEvent('cart:item-added', { bubbles: true, detail: { product: data?.items?.[0] || data } }));
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      }
      return true;
    } catch (error) {
      console.error('[DaLuca consolidated cart submit]', error);
      const message = error?.name === 'AbortError'
        ? 'The cart request took too long. Please try Add to Cart again.'
        : 'The cart could not be reached. Please try again.';
      showProxyCartValidation(state, [], message, false);
      return false;
    } finally {
      if (proxyButton) {
        proxyButton.disabled = false;
        proxyButton.classList.remove('loading');
        proxyButton.removeAttribute('aria-disabled');
      }
    }
  }

  function validationNode(issues, message) {
    const alert = document.createElement('div');
    alert.className = 'daluca-custom-summary__validation';
    alert.setAttribute('role', 'alert');
    alert.setAttribute('aria-live', 'assertive');
    const labels = (issues || []).map(item => item.label).filter(Boolean);
    const heading = document.createElement('strong');
    window.DaLucaI18n.setText(heading, labels.length ? 'Complete the required selections' : 'This strap is not ready to add yet');
    const copy = document.createElement('span');
    window.DaLucaI18n.setText(copy, labels.length
      ? 'Please choose: ' + labels.join(', ') + '.'
      : (message || 'Please review the build options above and complete any required selections.'));
    alert.append(heading, copy);
    return alert;
  }

  function clearProxyCartValidation(state) {
    if (!state) return;
    state.cartValidation = null;
    if (!state.builder) return;
    state.builder.querySelectorAll('.daluca-proxy-field.is-cart-missing').forEach(node => node.classList.remove('is-cart-missing'));
    state.builder.querySelector('.daluca-custom-summary__validation')?.remove();
  }

  function showProxyCartValidation(state, issues, message, includeUnselectedWhenBlocked) {
    if (!state?.builder) return;
    clearProxyCartValidation(state);
    state.cartValidation = { issues: issues || [], message: message || '', includeUnselectedWhenBlocked: !!includeUnselectedWhenBlocked };
    const summary = state.builder.querySelector('[data-daluca-proxy-summary]');
    const checkout = summary?.querySelector('.daluca-custom-builder-live__checkout');
    if (!summary || !checkout) return;

    const alert = validationNode(issues, message);
    summary.insertBefore(alert, checkout);

    (issues || []).forEach(item => {
      const proxy = state.builder.querySelector('[data-daluca-proxy-field="' + CSS.escape(item.name) + '"]');
      if (proxy) proxy.classList.add('is-cart-missing');
    });

    const first = (issues || []).map(item => state.builder.querySelector('[data-daluca-proxy-field="' + CSS.escape(item.name) + '"]')).find(Boolean);
    if (first) {
      first.scrollIntoView({ behavior: 'smooth', block: 'center' });
      const focusable = first.querySelector('select,button,input,textarea');
      window.setTimeout(() => focusable?.focus?.({ preventScroll: true }), 260);
    } else {
      alert.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }
  }

  function compactSummaryRow(row, state, selectedFields = state.fields) {
    const label = row.label;
    let value = row.value;
    let shortLabel = label;
    if (/^Short Strap Length/.test(label)) { shortLabel = 'Short length'; value = value.replace(/\s*\(.*$/, ''); }
    if (/^Long Strap Length/.test(label)) { shortLabel = 'Long length'; value = value.replace(/\s*\(.*$/, ''); }
    if (label === 'Thickness') value = value.replace(/\s*\(.*$/, '');
    if (label === 'Stitching Type') shortLabel = 'Stitching';
    if (label === 'Stitching Color') shortLabel = 'Thread';
    if (label === 'Edge Coating') shortLabel = 'Edge';
    if (label === 'Production Time') { shortLabel = 'Production'; value = value.replace('Standard - Ships in ', '').replace('Priority - Ships Within ', 'Priority · ').replace('Business Days', 'business days'); }
    if (label === 'Taper' && row.selected) {
      const lugField = (selectedFields || []).find(field => field.name === 'Lug Width');
      const lug = parseFloat(lugField ? selectedValue(lugField) : '');
      const taper = /^No Taper/i.test(value) ? 0 : /^([0-9.]+)mm Taper/i.test(value) ? parseFloat(value) : null;
      if (Number.isFinite(lug) && taper !== null) value = lug + ' → ' + (lug-taper) + ' mm';
    }
    value = value.replace(/\s*USD/g, '').replace(/\+\s+\$/g, '+$');
    return {label: shortLabel, value};
  }

  function setCustomSubmitPending(state, pending) {
    state.cartSubmitPending = pending;
    state.builder?.querySelectorAll('.daluca-proxy-add-to-cart').forEach(button => {
      button.disabled = pending;
      button.classList.toggle('loading', pending);
      if (pending) button.setAttribute('aria-disabled', 'true');
      else button.removeAttribute('aria-disabled');
    });
  }

  function makeSummary(state) {
    const summary = document.createElement('aside');
    summary.className = 'daluca-consolidated-summary daluca-custom-summary';
    summary.dataset.dalucaProxySummary = 'true';
    const selection = currentCartSelection(state);
    const rows = selectedSummaryRows(state, selection);
    const basePrice = basePriceNumber(state);
    const extrasPrice = selectedExtrasNumber(state, selection);
    const totalPrice = basePrice == null ? null : basePrice + extrasPrice;

    const eyebrow = document.createElement('span');
    eyebrow.className = 'daluca-custom-summary__eyebrow';
    window.DaLucaI18n.setText(eyebrow, 'Your selections');
    const heading = document.createElement('h3');
    window.DaLucaI18n.setText(heading, 'Your Custom Strap');
    summary.append(eyebrow, heading);

    const list = document.createElement('dl');
    list.className = 'daluca-consolidated-summary__list daluca-custom-summary__list';
    rows.filter(row => row.label !== 'Care & Installation' && !(/details|notes/i.test(row.label) && !row.selected)).forEach(row => {
      const compact = compactSummaryRow(row, state, selection.activeFields);
      const item = document.createElement('div');
      item.className = 'daluca-custom-summary__row' + (row.selected ? ' is-selected' : '');
      const dt = document.createElement('dt');
      const dd = document.createElement('dd');
      window.DaLucaI18n.setText(dt, compact.label);
      window.DaLucaI18n.setText(dd, compact.value);
      dd.title = /\bcolou?r$/i.test(row.label) ? window.DaLucaI18n.displayText(row.value) : row.value;
      item.append(dt, dd);
      list.appendChild(item);
    });
    summary.appendChild(list);
    const labels = state.root.dataset;
    const pricing = document.createElement('div');
    pricing.className = 'daluca-custom-summary__pricing';
    const line = (label, amount, className, isBase) => {
      const row = document.createElement('div');
      row.className = 'daluca-custom-summary__price-line' + (className ? ' ' + className : '');
      const name = document.createElement('span'); window.DaLucaI18n.setText(name, label);
      const value = document.createElement('strong'); window.DaLucaI18n.setText(value, amount);
      if (isBase) value.setAttribute('data-daluca-proxy-price', '');
      row.append(name, value); pricing.appendChild(row);
    };
    line(labels.dalucaLabelStrapPrice, money(basePrice), '', true);
    const paidEntries = selectedOptionPriceEntries(state, selection).concat(selectedCareEntries(state).filter(entry => Number(entry.price) > 0));
    paidEntries.forEach(entry => line(entry.title, '+' + money(Number(entry.price)), 'daluca-price-fee'));
    line(labels.dalucaLabelAddonsTotal, (extrasPrice > 0 ? '+' : '') + money(extrasPrice), 'daluca-price-extras-total');
    line(labels.dalucaLabelEstimatedTotal, money(totalPrice), 'daluca-custom-summary__price-line--total');
    summary.appendChild(pricing);

    const note = document.createElement('p');
    note.className = 'daluca-custom-summary__note';
    window.DaLucaI18n.setText(note, 'Your selections and final total are confirmed in the cart.');
    summary.appendChild(note);

    if (state.cartValidation) {
      const current = nativeAddButton(state);
      const persistedIssues = proxyCartIssues(state, state.cartValidation.includeUnselectedWhenBlocked || !!current?.disabled);
      if (persistedIssues.length || current?.disabled || state.cartValidation.message) {
        state.cartValidation.issues = persistedIssues;
        summary.appendChild(validationNode(persistedIssues, state.cartValidation.message));
      } else {
        state.cartValidation = null;
      }
    }

    const checkout = document.createElement('div');
    checkout.className = 'daluca-custom-builder-live__checkout';
    const nativeButton = nativeAddButton(state);
    if (nativeButton) {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'button full daluca-proxy-add-to-cart';
      window.DaLucaI18n.setText(button, clean(window.DaLucaI18n.sourceText(nativeButton) || nativeButton.value || 'Add to cart') || 'Add to cart');
      // Keep the proxy button actionable even when Globo has disabled its
      // hidden native button. A click can then explain exactly what is missing.
      button.disabled = !!state.cartSubmitPending;
      button.addEventListener('click', async () => {
        if (state.cartSubmitPending) return;
        setCustomSubmitPending(state, true);
        try {
        // Remove the obsolete hidden Venetian Cream requirement directly from
        // the live Globo DOM before *any* validator gets a chance to block.
        hardRetireLegacyVenetianDom(state);
        let current = nativeAddButton(state);
        let requiredIssues = proxyCartIssues(state, false);
        if (requiredIssues.length) {
          showProxyCartValidation(state, requiredIssues, '', false);
          return;
        }
        if (!current) {
          showProxyCartValidation(state, [], 'The product form is still loading. Please try again in a moment.', false);
          return;
        }

        // Globo can leave its hidden native submit button disabled even after
        // every visible builder choice is complete. Re-emit the current native
        // selections first so its own conditional/price validator gets a clean
        // final synchronization pass before we decide the build is blocked.
        if (current.disabled || current.getAttribute('aria-disabled') === 'true') {
          resyncNativeSelections(state);
          await new Promise(resolve => window.setTimeout(resolve, 90));
          current = nativeAddButton(state);
          requiredIssues = proxyCartIssues(state, false);
          if (requiredIssues.length) {
            showProxyCartValidation(state, requiredIssues, '', false);
            return;
          }
        }

        const form = nativeCartForm(state);
        if (!form) {
          showProxyCartValidation(state, [], 'The product form is still loading. Please try again in a moment.', false);
          return;
        }

        // The visible consolidated builder is the authority for required
        // choices. Remove any hidden/conditional native requirements before
        // submission instead of letting an invisible Globo field block cart.
        prepareNativeSubmission(state);
        const finalIssues = proxyCartIssues(state, false);
        if (finalIssues.length) {
          showProxyCartValidation(state, finalIssues, '', false);
          return;
        }

        if(window.DaLucaFinderHandoff&&!window.DaLucaFinderHandoff.validateProductForm(form))return;
        clearProxyCartValidation(state);

        if (window.DaLucaCartEditor?.isEditing?.(form)) {
          const configuration = snapshotCartConfiguration(state);
          await window.DaLucaCartEditor.save({
            form,
            variantId: resolvedVariantId(state, form),
            properties: configuration.properties,
            managedKeys: configuration.managedKeys,
            paidAmount: configuration.paidAmount,
            submit: async () => selectedOptionExtrasNumber(state) > 0
              ? submitThroughNativeButton(state, nativeAddButton(state))
              : ajaxSubmitConfiguredProduct(state, form, button)
          });
          return;
        }

        // Globo creates and links the paid-option cart items during its native
        // submission. A raw FormData POST can silently omit those surcharges.
        if (selectedOptionExtrasNumber(state) > 0) {
          if (!submitThroughNativeButton(state, nativeAddButton(state))) {
            showProxyCartValidation(state, [], 'The priced options are not ready to add yet. Please review your selections or contact DaLuca for help with this build.', false);
          } else {
            const submission = form.closest('product-form')?.submissionPromise;
            if (submission) await submission;
          }
          return;
        }
        await ajaxSubmitConfiguredProduct(state, form, button);
        } finally {
          setCustomSubmitPending(state, false);
        }
      });
      checkout.appendChild(button);
    }
    summary.appendChild(checkout);
    return summary;
  }

  function replaceSummaryPreserveCheckout(state) {
    if (!state?.builder) return;
    const oldSummary = state.builder.querySelector('[data-daluca-proxy-summary]');
    if (!oldSummary) return;
    const stableCheckout = oldSummary.querySelector('.daluca-custom-builder-live__checkout');
    const nextSummary = makeSummary(state);
    const nextCheckout = nextSummary.querySelector('.daluca-custom-builder-live__checkout');
    if (!stableCheckout || !nextCheckout) {
      oldSummary.replaceWith(nextSummary);
      return;
    }
    nextCheckout.remove();
    const content = nextSummary.innerHTML;
    if (state.summaryContent === content) return;
    state.summaryContent = content;
    // Keep the live checkout button and its ancestors connected while options
    // refresh; replacing them between pointer-down and pointer-up loses clicks.
    Array.from(oldSummary.children).forEach(node => {
      if (node !== stableCheckout) node.remove();
    });
    while (nextSummary.firstChild) oldSummary.insertBefore(nextSummary.firstChild, stableCheckout);
  }

  function refreshProxySummary(state) {
    replaceSummaryPreserveCheckout(state);
  }

  function cleanupSizingGuideSeparators(state) {
    const opener = state?.root?.querySelector('modal-opener.product-popup-modal__opener, .product-popup-modal__opener');
    if (!opener) return;
    opener.classList.add('daluca-sizing-guide-clean-v38');

    // Globo/concierge can leave suppressed nodes between the description and
    // Sizing Guide. Mark the nearest *visible* predecessor, not simply the
    // previousElementSibling, so its border cannot create a second rule.
    let cursor = opener.previousElementSibling;
    let inspected = 0;
    while (cursor && inspected < 10) {
      const style = getComputedStyle(cursor);
      const suppressed = cursor.hidden || cursor.classList.contains('daluca-consolidated-top-suppressed') || style.display === 'none';
      if (cursor.matches('hr,[class*="divider"],[class*="separator"]')) {
        cursor.classList.add('daluca-sizing-guide-orphan-rule-v38');
      } else if (suppressed) {
        cursor.classList.add('daluca-sizing-guide-suppressed-before-v39');
      } else {
        cursor.classList.add('daluca-before-sizing-guide-v38');
        if (opener.classList.contains('daluca-sizing-guide-direct-v318')) {
          cursor.style.setProperty('margin-bottom', '0', 'important');
          cursor.style.setProperty('padding-bottom', '0', 'important');
          cursor.style.setProperty('border-bottom', '0', 'important');
        }
        break;
      }
      cursor = cursor.previousElementSibling;
      inspected += 1;
    }

    // The real Habitat/concierge stack can draw a rule on a suppressed fit
    // block even though its contents are hidden. Strip those structural rules
    // directly so there is never a phantom second line above Sizing Guide.
    state.root.querySelectorAll('.daluca-consolidated-top-suppressed').forEach(node => {
      if (node.compareDocumentPosition(opener) & Node.DOCUMENT_POSITION_FOLLOWING) {
        node.classList.add('daluca-sizing-guide-suppressed-before-v39');
      }
    });
  }

  function builderInsertionPoint(state) {
    // V3.35: Liquid owns a dedicated full-width mount immediately after the
    // two-column hero. This prevents the builder from ever being injected into
    // the right product-information column when Habitat or an app reshuffles DOM.
    const mount = document.querySelector('[data-daluca-custom-builder-mount]');
    if (mount) return { parent: mount, before: null };
    if (state.root?.parentNode) return { parent: state.root.parentNode, before: state.root.nextSibling };
    return null;
  }

  function render(state) {
    const fields = neutralizeLegacyVenetianCream(state, collectFields(state.app, state.profile));
    applyBuckleAvailability(state, fields);
    state.fields = fields;
    basePriceNumber(state);

    state.app.classList.add('daluca-custom-native-source--consolidated');
    state.app.setAttribute('data-daluca-native-source', 'true');

    const old = document.querySelector('.daluca-custom-consolidated-builder[data-daluca-profile="' + CSS.escape(state.handle) + '"]');
    let preservedVisualizer = document.querySelector('.daluca-visualizer[data-daluca-visualizer]');
    if (old) {
      // Preserve native initialized widgets before replacing the proxy builder.
      restoreEmbeddedFitChecker(old, state);
      // V4.29: keep the visualizer alive across conditional Globo builder re-renders.
      // Moving it back to the dedicated mount before old.remove() prevents Strap Style
      // changes (especially Military/1 Piece) from deleting the visualizer node.
      if (preservedVisualizer && old.contains(preservedVisualizer)) {
        const visualizerMount = document.querySelector('[data-daluca-custom-builder-mount]');
        if (visualizerMount) visualizerMount.appendChild(preservedVisualizer);
        else if (state.root?.parentNode) state.root.parentNode.insertBefore(preservedVisualizer, state.root.nextSibling);
      }
      old.remove();
    }

    const builder = document.createElement('section');
    builder.className = 'daluca-custom-consolidated-builder daluca-custom-builder-live daluca-custom-builder-live--consolidated';
    builder.dataset.dalucaBuild = BUILD;
    builder.dataset.dalucaProfile = state.handle;
    builder.setAttribute('aria-label', 'Build your custom strap');

    const header = document.createElement('div');
    header.className = 'daluca-custom-builder-live__header';
    const family = state.profile?.family || state.root?.dataset?.dalucaCustomFamily || 'two-piece';
    const builderCopy = state.handle === 'the-74-vintage-leather-watch-strap'
      ? 'Choose your exact fit, leather color and whether to add the “74” marking. Then select production time and any optional extras.'
      : family === 'military'
      ? 'Your watch. Your specifications. Choose the fit, military construction, leather, stitching, hardware and finishing details that make the strap yours.'
      : 'Your watch. Your specifications. Choose the fit, leather, stitching, hardware and finishing details that make the strap yours.';
    window.DaLucaI18n.setHtml(header, '<div><span class="daluca-custom-builder-live__eyebrow">Made to order</span><h2>Build Your Custom Strap</h2><p>' + builderCopy + '</p></div><a class="daluca-custom-builder-live__help" href="/pages/strap-finder">Need sizing help? Open Strap Finder</a>');
    builder.appendChild(header);

    const visible = orderedFields(
      fields.filter(field => field.isExpected && field.name !== 'Care & Installation'),
      state.profile
    ).filter(nativeVisible);
    const bySection = new Map();
    visible.forEach(field => {
      const key = sectionFor(field);
      if (!bySection.has(key)) bySection.set(key, []);
      bySection.get(key).push(field);
    });

    const layout = document.createElement('div');
    layout.className = 'daluca-custom-builder-live__layout';
    const options = document.createElement('div');
    options.className = 'daluca-custom-builder-live__options';
    const columns = document.createElement('div');
    columns.className = 'daluca-custom-builder-columns';

    const order = ['fit','leather','stitching','hardware','extras','details'];
    order.forEach(key => {
      const group = bySection.get(key);
      if (!group?.length) return;
      const section = makeSection(key, group, state);
      if (state.handle === 'the-74-vintage-leather-watch-strap') window.DaLucaI18n.setText(section.querySelector('.daluca-builder-section__number'), String(columns.children.length + 1).padStart(2, '0'));
      columns.appendChild(section);
    });
    if (family === 'military' && !visible.some(field => /^Buckle/.test(field.name))) {
      const hint = document.createElement('p');
      hint.className = 'daluca-builder-hardware-hint';
      window.DaLucaI18n.setText(hint, 'Hardware: choose your lug width and strap style to see the compatible buckle finishes. Matte Silver and PVD Black are shown where available. Leather keepers are offered for the 1 Piece style and include an INOX polished buckle.');
      columns.appendChild(hint);
    }
    applySequentialRefs(columns, state);
    // V4.29: Visualizer occupies the top of the left configuration column while
    // Your Selections remains the sticky right column. This lets both stay visible.
    preservedVisualizer = preservedVisualizer || document.querySelector('.daluca-visualizer[data-daluca-visualizer]');
    if (preservedVisualizer) {
      preservedVisualizer.classList.add('daluca-visualizer--builder-left');
      options.appendChild(preservedVisualizer);
    }
    options.appendChild(columns);
    layout.append(options, makeSummary(state));
    builder.appendChild(layout);

    const point = builderInsertionPoint(state);
    if (point) {
      if (point.before) point.parent.insertBefore(builder, point.before);
      else point.parent.appendChild(builder);
    } else state.app.parentNode.insertBefore(builder, state.app);

    suppressTopConfiguratorChrome(state);
    cleanupSizingGuideSeparators(state);
    bindOptionPreviews();

    const cartForm = nativeCartForm(state);
    if (cartForm) cartForm.classList.add('daluca-native-cart-source--consolidated');

    state.builder = builder;
    state.signature = fieldSignature(fields);
    syncProxyState(state);
  }

  function fieldSignature(fields) {
    return fields.map(field => field.name + ':' + field.controls.length + ':' + (nativeVisible(field) ? '1' : '0')).sort().join('|');
  }

  function syncProxyState(state) {
    forceLegacyVenetianOff(state);
    if (!state.builder || !document.documentElement.contains(state.builder)) return;
    const fresh = neutralizeLegacyVenetianCream(state, collectFields(state.app, state.profile));
    applyBuckleAvailability(state, fresh);
    const signature = fieldSignature(fresh);
    if (signature !== state.signature) {
      render(state);
      return;
    }
    state.fields = fresh;

    fresh.forEach(field => {
      const proxy = state.builder.querySelector('[data-daluca-proxy-field="' + CSS.escape(field.name) + '"]');
      if (!proxy) return;
      proxy.hidden = !nativeVisible(field);
      const select = proxy.querySelector('select');
      const nativeSelect = field.controls.find(control => control.tagName === 'SELECT');
      if (select && nativeSelect) {
        select.value = nativeSelect.value;
        select.disabled = nativeSelect.disabled;
        Array.from(select.options).forEach((option, index) => {
          const source = nativeSelect.options[index];
          option.hidden = source?.dataset.dalucaBuckleUnavailable === 'true';
          option.disabled = !!source?.disabled || option.hidden;
        });
      }
      proxy.querySelectorAll('.daluca-proxy-choice').forEach(button => {
        const id = button.dataset.nativeId;
        const input = id ? document.getElementById(id) : null;
        if (!input) return;
        const unavailable = input.dataset.dalucaBuckleUnavailable === 'true';
        button.disabled = input.disabled || unavailable;
        if (unavailable) button.style.setProperty('display', 'none', 'important');
        else button.style.removeProperty('display');
        button.classList.toggle('is-selected', !!input.checked);
        button.setAttribute('aria-pressed', input.checked ? 'true' : 'false');
      });
      const textProxy = proxy.querySelector('.daluca-proxy-text');
      const nativeText = field.controls.find(control => control.tagName === 'TEXTAREA' || ['text','number','search','email'].includes(control.type));
      if (textProxy && nativeText && document.activeElement !== textProxy) textProxy.value = nativeText.value || '';
    });

    syncCareEligibility(state);
    const visualizerSignature = fresh.map(field => field.name + ':' + selectedValue(field)).join('|');
    if (state.visualizerSignature !== visualizerSignature) {
      state.visualizerSignature = visualizerSignature;
      state.builder.dispatchEvent(new CustomEvent('daluca:custom-options-change', { bubbles: true }));
    }
    replaceSummaryPreserveCheckout(state);
    syncFloatingSummary(state);
    suppressTopConfiguratorChrome(state);
    cleanupSizingGuideSeparators(state);
  }

  function syncFloatingSummary(state) {
    const summary = state.builder?.querySelector('.daluca-custom-summary');
    if (!summary) return;
    if (!state.summaryLayout) {
      state.summaryLayout = () => {
        cancelAnimationFrame(state.summaryFrame);
        state.summaryFrame = requestAnimationFrame(() => {
          const current = state.builder?.querySelector('.daluca-custom-summary');
          if (!current?.isConnected) return;
          const viewport = window.visualViewport?.height || window.innerHeight;
          const preview = document.getElementById('PBarNextFrame');
          const barHeight = preview ? Math.min(80, Math.max(0, preview.getBoundingClientRect().height)) : 0;
          const top = Math.min(72, viewport - barHeight - 16 - current.getBoundingClientRect().height);
          current.style.setProperty('--daluca-summary-sticky-top', Math.round(top) + 'px');
        });
      };
      window.addEventListener('resize', state.summaryLayout, {passive:true});
      window.visualViewport?.addEventListener('resize', state.summaryLayout, {passive:true});
      if (window.ResizeObserver) state.summarySizeObserver = new ResizeObserver(state.summaryLayout);
    }
    if (state.observedSummary !== summary) {
      state.summarySizeObserver?.disconnect();
      state.summarySizeObserver?.observe(summary);
      const preview = document.getElementById('PBarNextFrame');
      if (preview) state.summarySizeObserver?.observe(preview);
      state.observedSummary = summary;
    }
    state.summaryLayout();
  }

  function queueSync(state, delay) {
    clearTimeout(state.syncTimer);
    state.syncTimer = setTimeout(() => syncProxyState(state), delay || 40);
  }

  function bind(state) {
    state.app.addEventListener('change', () => queueSync(state, 35), true);
    state.app.addEventListener('input', () => queueSync(state, 70), true);
    state.root.addEventListener('variant:change', () => queueSync(state, 80));

    if (window.MutationObserver) {
      const observer = new MutationObserver(mutations => {
        const relevant = mutations.some(mutation => {
          if (mutation.type === 'childList') return mutation.addedNodes.length || mutation.removedNodes.length;
          return ['class','style','hidden','checked','disabled','aria-hidden'].includes(mutation.attributeName);
        });
        if (relevant) queueSync(state, 55);
      });
      observer.observe(state.app, { subtree: true, childList: true, attributes: true, attributeFilter: ['class','style','hidden','checked','disabled','aria-hidden'] });
      state.observer = observer;
    }

    if (window.MutationObserver) {
      const priceTarget = state.root.querySelector('.product-price-container,[data-product-price]');
      if (priceTarget) {
        const priceObserver = new MutationObserver(() => queueSync(state, 100));
        priceObserver.observe(priceTarget, { subtree: true, childList: true, characterData: true });
        state.priceObserver = priceObserver;
      }
    }
  }

  function waitForApp(r, callback) {
    const start = Date.now();
    const tryFind = () => {
      const app = getAppRoot(r);
      if (app) return callback(app);
      if (Date.now() - start < 12000) setTimeout(tryFind, 120);
      else console.warn('[DaLuca Custom V3] Globo controls were not found within 12 seconds.');
    };
    tryFind();
  }

  function init() {
    const r = root();
    if (!r || r.dataset.dalucaConsolidatedReady === '1') return;
    const h = handle();
    const profileDef = PROFILES[h];
    if (!profileDef) {
      console.warn('[DaLuca Custom V3] No explicit profile for', h);
      return;
    }
    r.dataset.dalucaConsolidatedReady = '1';
    waitForApp(r, app => {
      const state = { root: r, app, handle: h, profile: profileDef, fields: [], builder: null, signature: '', syncTimer: null, careSelections: {}, legacyVenetianRetired: false, legacyVenetianForcedOff: false };
      window.__dalucaCustomConsolidatedState = state;
      document.documentElement.setAttribute('data-daluca-custom-build', BUILD);
      render(state);
      bind(state);
      [180, 500, 1100, 2200, 4200].forEach(ms => setTimeout(() => syncProxyState(state), ms));
      if (new URLSearchParams(location.search).get('daluca_custom_audit') === '1') {
        setTimeout(() => window.DaLucaCustomAudit?.run(), 1300);
      }
    });
  }

  function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  async function auditField(field, state) {
    const result = {
      field: field.name,
      expected: field.isExpected,
      visible: nativeVisible(field),
      proxyPresent: !!state.builder?.querySelector('[data-daluca-proxy-field="' + CSS.escape(field.name) + '"]'),
      choices: 0,
      tested: 0,
      passed: 0,
      failures: []
    };
    if (!result.visible) return result;

    const select = field.controls.find(control => control.tagName === 'SELECT');
    if (select) {
      const original = select.value;
      const options = Array.from(select.options).filter(option => !option.disabled && option.value !== '');
      result.choices = options.length;
      for (const option of options) {
        setSelect(select, option.value);
        await sleep(35);
        result.tested += 1;
        if (select.value === option.value) result.passed += 1;
        else result.failures.push('Select did not retain ' + clean(window.DaLucaI18n.sourceText(option)));
      }
      setSelect(select, original);
      await sleep(20);
      return result;
    }

    const choices = field.controls.filter(control => /^(radio|checkbox)$/i.test(control.type) && !control.disabled);
    result.choices = choices.length;
    const originalStates = new Map(choices.map(input => [input, !!input.checked]));
    for (const input of choices) {
      if (input.type === 'checkbox' && input.checked) input.click();
      input.click();
      await sleep(35);
      result.tested += 1;
      if (input.checked) result.passed += 1;
      else result.failures.push('Choice did not become selected: ' + optionText(input));
    }
    for (const [input, checked] of originalStates) {
      if (input.type === 'radio') {
        if (checked && !input.checked) input.click();
      } else if (input.checked !== checked) {
        input.click();
      }
    }

    const textControl = field.controls.find(control => control.tagName === 'TEXTAREA' || ['text','number','search','email'].includes(control.type));
    if (!choices.length && textControl && !textControl.disabled) {
      const original = textControl.value;
      const probe = textControl.type === 'number' ? '1' : 'DaLuca audit';
      setText(textControl, probe);
      await sleep(25);
      result.choices = 1;
      result.tested = 1;
      if (String(textControl.value) === probe) result.passed = 1;
      else result.failures.push('Text control did not accept a value.');
      setText(textControl, original);
    }
    return result;
  }

  async function runAudit() {
    const state = window.__dalucaCustomConsolidatedState;
    if (!state) return { pass: false, error: 'Consolidated custom runtime is not initialized.' };
    syncProxyState(state);
    await sleep(80);

    const fields = collectFields(state.app, state.profile);
    const names = new Set(fields.map(field => field.name));
    const missingRequired = state.profile.required.filter(name => !names.has(name));
    const unmapped = fields.filter(field => !field.isExpected).map(field => field.name);
    const visible = fields.filter(nativeVisible);
    const fieldResults = [];

    for (const field of visible) fieldResults.push(await auditField(field, state));
    syncProxyState(state);
    await sleep(80);

    const rRect = state.root.getBoundingClientRect();
    const overflowing = Array.from(state.builder.querySelectorAll('.daluca-proxy-field,.daluca-consolidated-section')).filter(el => {
      const rect = el.getBoundingClientRect();
      return rect.right > Math.max(rRect.right, document.documentElement.clientWidth) + 2 || rect.left < -2;
    }).length;

    const nativeStillInApp = fields.every(field => field.controls.every(control => state.app.contains(control)));
    const proxyCount = state.builder.querySelectorAll('[data-daluca-proxy-field]').length;
    const clickFailures = fieldResults.reduce((sum, result) => sum + result.failures.length, 0);
    const form = state.root.querySelector('form[action*="/cart/add"]');
    const addButton = form?.querySelector('button[name="add"],button[type="submit"],input[type="submit"]') || null;
    const nativePropertiesInForm = form ? Array.from(form.querySelectorAll('[name^="properties["]')).length : 0;
    const runtimeErrors = Array.from(new Set(window.__dalucaCustomRuntimeErrors || []));

    const report = {
      build: BUILD,
      handle: state.handle,
      pass: missingRequired.length === 0 && clickFailures === 0 && nativeStillInApp && overflowing === 0 && !!form && !!addButton && runtimeErrors.length === 0,
      nativeFieldCount: fields.length,
      visibleFieldCount: visible.length,
      proxyFieldCount: proxyCount,
      missingRequired,
      unmapped,
      nativeControlsUntouchedInApp: nativeStillInApp,
      cartFormPresent: !!form,
      addButtonPresent: !!addButton,
      nativePropertiesInCartForm: nativePropertiesInForm,
      horizontalOverflowCount: overflowing,
      clickFailures,
      runtimeErrors,
      fields: fieldResults,
      timestamp: new Date().toISOString()
    };
    window.__dalucaCustomAuditReport = report;
    console.group('[DaLuca Custom V3 Audit] ' + state.handle);
    console.table(fieldResults.map(item => ({ field: item.field, visible: item.visible, choices: item.choices, tested: item.tested, passed: item.passed, failures: item.failures.length })));
    console.log(report);
    console.groupEnd();
    return report;
  }

  function cartChoiceValue(field, value) {
    if (/details|notes|instructions/i.test(field.name)) return clean(value);
    let text = clean(value).replace(/\s*\(\+\s*(?:[A-Z]{3}\s*)?[$€£¥₹₩₽₫₪]?\s*[\d,.]+(?:\s*[A-Z]{3})?\)\s*$/i, '');
    if (field.name === '74') {
      if (/^yes(?:$|\s*[—–-])/i.test(text)) text = 'yes';
      if (/^no(?:$|\s*[—–-])/i.test(text)) text = 'no';
    }
    if (field.name === 'Strap Style') {
      if (/1\s*piece|one\s*piece/i.test(text)) text = '1 Piece';
      else if (/military/i.test(text)) text = 'Military';
    }
    return text.toLowerCase();
  }

  function cartPropertyName(value) {
    return canonicalName(value).toLowerCase();
  }

  function cartFieldPropertyKeys(field) {
    return [field.name, field.displayLabel, ...Array.from(field.rawNames || []),
      ...field.controls.map(control => {
        const name = control.getAttribute('name') || '';
        return name.match(/^properties\[(.*)\]$/)?.[1] || '';
      })].filter(name => name && name[0] !== '_');
  }

  function cartSavedField(field, properties) {
    const names = new Set(cartFieldPropertyKeys(field).map(cartPropertyName));
    const entries = Object.entries(properties || {}).filter(([name, value]) => name[0] !== '_' && names.has(cartPropertyName(name)) && value != null);
    const nativeNames = field.controls.map(control => (control.getAttribute('name') || '').match(/^properties\[(.*)\]$/)?.[1]).filter(Boolean);
    const rank = name => (nativeNames.includes(name) ? 2 : 0) + Number(name === field.displayLabel);
    entries.sort(([left], [right]) => rank(right) - rank(left));
    const controls = cartFieldControls(field);
    const choices = controls.flatMap(control => control.tagName === 'SELECT'
      ? Array.from(control.options).map(option => ({ value: option.value, label: window.DaLucaI18n.sourceText(option) }))
      : control.type === 'radio' ? [{ value: control.value, label: optionText(control) }] : []);
    if (entries.length && choices.length) {
      let possible = choices.map((_, index) => index);
      entries.forEach(([, value]) => {
        const expected = cartChoiceValue(field, value);
        const matching = choices.flatMap((choice, index) => cartChoiceValue(field, choice.value) === expected || cartChoiceValue(field, choice.label) === expected ? [index] : []);
        possible = possible.filter(index => matching.includes(index));
      });
      return { present: true, conflict: possible.length !== 1, value: possible.length === 1 ? String(choices[possible[0]].value) : String(entries[0][1]) };
    }
    const checkboxes = controls.filter(control => control.type === 'checkbox');
    if (entries.length && checkboxes.length) {
      const selections = entries.map(([, value]) => cartCheckboxSelection(field, checkboxes, value));
      const signatures = new Set(selections.filter(Boolean).map(items => items.map(control => checkboxes.indexOf(control)).join(',')));
      return { present: true, conflict: selections.some(items => !items) || signatures.size !== 1, value: String(entries[0][1]) };
    }
    const values = new Set(entries.map(([, value]) => cartChoiceValue(field, value)));
    return {
      present: entries.length > 0 || /details|notes|instructions/i.test(field.name),
      conflict: values.size > 1,
      value: entries.length ? String(entries[0][1]) : ''
    };
  }

  function cartFieldControls(field) {
    return field.controls.filter(control => control.isConnected && !control.disabled &&
      control.dataset.dalucaBuckleUnavailable !== 'true' &&
      (/details|notes|instructions/i.test(field.name) || nativeVisible({
        ...field,
        containers: [fieldContainerForControl(control, field.name, field.app)]
      })));
  }

  function currentCartSelection(state) {
    if (!state?.app || !state.profile) return { fields: [], activeFields: [] };
    // Rebuilt Globo controls can leave state.fields pointing at old selections.
    // Share this fresh read across cart properties, fee totals and summary rows.
    const fields = neutralizeLegacyVenetianCream(state, collectFields(state.app, state.profile));
    return {
      fields,
      activeFields: fields.map(field => ({ ...field, controls: cartFieldControls(field) }))
    };
  }

  function selectedCartValue(field) {
    const controls = cartFieldControls(field);
    if (field.name !== 'Strap Style') return selectedValue({ ...field, controls });
    const select = controls.find(control => control.tagName === 'SELECT');
    if (select) return clean(select.value);
    return clean(controls.filter(control => /^(radio|checkbox)$/i.test(control.type) && control.checked)
      .map(control => control.value).join(', '));
  }

  function cartFieldMatches(field, saved) {
    if (!saved.present) return true;
    if (saved.conflict) return false;
    const controls = cartFieldControls(field);
    if (!controls.length) return false;
    const expected = cartChoiceValue(field, saved.value);
    const active = { ...field, controls };
    if (cartChoiceValue(field, selectedValue(active)) === expected) return true;
    const select = controls.find(control => control.tagName === 'SELECT');
    if (select) return cartChoiceValue(field, select.value) === expected;
    const selected = controls.filter(control => /^(radio|checkbox)$/i.test(control.type) && control.checked);
    return selected.length > 0 && cartChoiceValue(field, selected.map(control => control.value).join(', ')) === expected;
  }

  function cartCheckboxSelection(field, controls, value) {
    const target = cartChoiceValue(field, value);
    if (!target) return [];
    const matches = new Map();
    function visit(index, remaining, selected) {
      if (matches.size > 1) return;
      if (!remaining) {
        matches.set(selected.join(','), selected);
        return;
      }
      if (index >= controls.length) return;
      const labels = new Set([controls[index].value, optionText(controls[index])].map(text => cartChoiceValue(field, text)).filter(Boolean));
      labels.forEach(label => {
        if (remaining === label) visit(index + 1, '', selected.concat(index));
        else if (remaining.startsWith(label + ', ')) visit(index + 1, remaining.slice(label.length + 2), selected.concat(index));
      });
      visit(index + 1, remaining, selected);
    }
    visit(0, target, []);
    if (matches.size !== 1) return null;
    return Array.from(matches.values())[0].map(index => controls[index]);
  }

  function restoreCartField(field, saved) {
    if (!saved.present || saved.conflict || cartFieldMatches(field, saved)) return false;
    const controls = cartFieldControls(field);
    const expected = cartChoiceValue(field, saved.value);
    const selects = controls.filter(control => control.tagName === 'SELECT' && !control.multiple);
    if (selects.length) {
      const choices = selects.flatMap(control => Array.from(control.options).filter(option => !option.disabled && !option.hidden && option.dataset.dalucaBuckleUnavailable !== 'true').map(option => ({ control, option })));
      const exact = choices.filter(choice => cartChoiceValue(field, choice.option.value) === expected);
      const matches = exact.length ? exact : choices.filter(choice => cartChoiceValue(field, window.DaLucaI18n.sourceText(choice.option)) === expected);
      if (matches.length !== 1) return false;
      setSelect(matches[0].control, matches[0].option.value);
      return true;
    }
    const radios = controls.filter(control => control.type === 'radio');
    if (radios.length) {
      const exact = radios.filter(control => cartChoiceValue(field, control.value) === expected);
      const matches = exact.length ? exact : radios.filter(control => cartChoiceValue(field, optionText(control)) === expected);
      if (matches.length !== 1) return false;
      matches[0].click();
      return true;
    }
    const checkboxes = controls.filter(control => control.type === 'checkbox');
    if (checkboxes.length) {
      const chosen = cartCheckboxSelection(field, checkboxes, saved.value);
      if (!chosen) return false;
      let changed = false;
      checkboxes.forEach(control => {
        if (control.checked !== chosen.includes(control)) {
          control.click();
          changed = true;
        }
      });
      return changed;
    }
    const text = controls.find(control => control.tagName === 'TEXTAREA' || ['text', 'number', 'search', 'email'].includes(control.type));
    if (!text) return false;
    setText(text, saved.value);
    return true;
  }

  function cartConfigurationFields(state) {
    return orderedFields(collectFields(state.app, state.profile), state.profile).filter(field =>
      field.isExpected && field.name !== 'Venetian Cream' && field.name !== 'Care & Installation');
  }

  function cartManagedProperties(state, currentFields) {
    const keys = new Map();
    const profileFields = state.profile.fields.filter(name => name !== 'Venetian Cream' && name !== 'Care & Installation');
    profileFields.forEach(name => {
      const label = state.profile.labels[name] || FIELD_META[name]?.label || name;
      keys.set(name, label);
      keys.set(label, label);
    });
    Object.entries(ALIASES).forEach(([alias, name]) => {
      if (profileFields.includes(name)) keys.set(alias, state.profile.labels[name] || FIELD_META[name]?.label || name);
    });
    (currentFields || cartConfigurationFields(state)).filter(field => field.isExpected &&
      field.name !== 'Venetian Cream' && field.name !== 'Care & Installation').forEach(field => {
      cartFieldPropertyKeys(field).forEach(name => keys.set(name, field.displayLabel || field.name));
    });
    (state.cartEditorManagedKeys || []).forEach(name => {
      if (!keys.has(name)) keys.set(name, name);
    });
    return keys;
  }

  function cartRestoreMissing(state, properties) {
    const fields = cartConfigurationFields(state).filter(field => nativeVisible(field) || /details|notes|instructions/i.test(field.name));
    const known = new Map(Array.from(cartManagedProperties(state), ([name, label]) => [cartPropertyName(name), label]));
    const missing = fields.filter(field => !cartFieldMatches(field, cartSavedField(field, properties))).map(field => field.displayLabel || field.name);
    Object.entries(properties || {}).forEach(([name, value]) => {
      if (name[0] === '_' || value == null || !known.has(cartPropertyName(name))) return;
      const matches = fields.filter(field => cartFieldPropertyKeys(field).some(key => cartPropertyName(key) === cartPropertyName(name)));
      if (!matches.some(field => cartFieldMatches(field, { present: true, conflict: false, value: String(value) }))) missing.push(known.get(cartPropertyName(name)));
    });
    return Array.from(new Set(missing));
  }

  function snapshotCartConfiguration(state) {
    const properties = {};
    if (!state) return { variantId: '', properties, paid: false, paidAmount: 0, managedKeys: [] };
    const selection = currentCartSelection(state);
    const data = new FormData();
    appendConfiguredProperties(state, data, false, selection);
    data.forEach((value, name) => {
      const match = name.match(/^properties\[(.+)\]$/);
      if (match) properties[match[1]] = String(value);
    });
    const propertyAliases = {};
    selection.activeFields.filter(field => field.isExpected && field.name !== 'Venetian Cream' && field.name !== 'Care & Installation').forEach(field => {
      const label = clean(field.displayLabel || field.name);
      if (label) propertyAliases[label] = nativeCartFieldAliases(field).filter(alias => alias !== label);
    });
    const nativeProperties = nativeCartPropertyValues(selection, new FormData(nativeCartForm(state)));
    const paidAmount = selectedOptionExtrasNumber(state, selection);
    return { variantId: resolvedVariantId(state, nativeCartForm(state)), properties, propertyAliases, nativeProperties, paid: paidAmount > 0, paidAmount, managedKeys: Array.from(cartManagedProperties(state, selection.fields).keys()) };
  }

  window.DaLucaCustomCartAdapter = {
    getForm: () => nativeCartForm(window.__dalucaCustomConsolidatedState),
    getRoot: () => window.__dalucaCustomConsolidatedState?.root || root(),
    getBuilder: () => window.__dalucaCustomConsolidatedState?.builder || null,
    prepareAccessories() {
      const state = window.__dalucaCustomConsolidatedState;
      if (state) syncCareEligibility(state);
    },
    hasPendingAccessories() {
      const state = window.__dalucaCustomConsolidatedState;
      return !!state && (!!state.creamRemovalPending || (!creamAllowed(state) && !!state.careSelections?.cream));
    },
    isReady: () => !!window.__dalucaCustomConsolidatedState?.builder?.isConnected,
    async restore(properties) {
      const state = window.__dalucaCustomConsolidatedState;
      if (!state?.builder?.isConnected || !state.app?.isConnected) return { ok: false, missing: [] };
      const knownNames = new Set(Array.from(cartManagedProperties(state).keys(), cartPropertyName));
      state.cartEditorManagedKeys = Object.keys(properties || {}).filter(name => name[0] !== '_' && knownNames.has(cartPropertyName(name)));
      let previousSignature = '';
      let interrupted = false;
      const onUserInput = event => {
        if (event.isTrusted && event.target.closest?.('input,select,textarea,.daluca-proxy-choice')) interrupted = true;
      };
      const inputScope = state.root.closest('.shopify-section') || state.root;
      inputScope.addEventListener('pointerdown', onUserInput, true);
      inputScope.addEventListener('keydown', onUserInput, true);
      try {
        for (let pass = 0; pass < 6; pass += 1) {
          const names = cartConfigurationFields(state).map(field => field.name);
          for (const name of names) {
            if (!state.root.isConnected || !state.app.isConnected) return { ok: false, missing: [] };
            if (interrupted) return { ok: false, missing: cartRestoreMissing(state, properties) };
            const field = cartConfigurationFields(state).find(item => item.name === name);
            if (!field || (!nativeVisible(field) && !/details|notes|instructions/i.test(field.name))) continue;
            if (restoreCartField(field, cartSavedField(field, properties))) {
              await sleep(90);
              syncProxyState(state);
            }
          }
          await sleep(180);
          syncProxyState(state);
          const fields = cartConfigurationFields(state).filter(field => nativeVisible(field) || /details|notes|instructions/i.test(field.name));
          const missing = cartRestoreMissing(state, properties);
          const signature = JSON.stringify(fields.map(field => [field.name, selectedValue({ ...field, controls: cartFieldControls(field) })]));
          if (interrupted) return { ok: false, missing };
          if (!missing.length && signature === previousSignature) return { ok: true, missing: [] };
          previousSignature = signature;
          if (pass === 5) return { ok: false, missing };
        }
        return { ok: false, missing: [] };
      } finally {
        inputScope.removeEventListener('pointerdown', onUserInput, true);
        inputScope.removeEventListener('keydown', onUserInput, true);
      }
    },
    snapshot: () => snapshotCartConfiguration(window.__dalucaCustomConsolidatedState),
    refresh() {
      const state = window.__dalucaCustomConsolidatedState;
      if (state?.builder?.isConnected) syncProxyState(state);
    }
  };

  window.DaLucaCustomAudit = {
    build: BUILD,
    profiles: PROFILES,
    run: runAudit,
    snapshot: function () {
      const state = window.__dalucaCustomConsolidatedState;
      if (!state) return null;
      return {
        handle: state.handle,
        fields: collectFields(state.app, state.profile).map(field => ({ name: field.name, visible: nativeVisible(field), selected: selectedValue(field), expected: field.isExpected }))
      };
    }
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', init);
})();







